import type { I18nTranslations } from './i18n-en';

const i18n_de: I18nTranslations = {
  close_btn: 'Schließen',
  search_placeholder: 'Suchen',
  loading: 'Laden',

  label_inactive: 'Inaktiv',
  label_invalid: 'Ungültig',

  active_devices: 'Anzahl aktiver Geräte: {{devices_len}}',
  change_language: 'Sprache auswählen',
  language_changed_message: 'Sprache geändert',

  error_select_device_message: 'Bitte wählen Sie zuerst das Gerät aus',
  select_device: 'Gerät auswählen',
  select_company_menu_message: 'Wählen Sie ein Unternehmen aus, um die Geräteliste anzuzeigen',
  select_company_required_header: 'Wählen Sie ein Unternehmen aus, um fortzufahren',
  select_company_required_from: 'Von hier aus: ',
  select_company_required_accounts_page_link: 'Kontoseite',

  second: 'Sekunde',
  seconds: 'Sekunden',
  second_one: 'Sekunde',
  second_other: 'Sekunden',
  minute: 'Minute',
  minutes: 'Minuten',
  minute_one: 'Minute',
  minute_other: 'Minuten',
  hour: 'Stunde',
  hours: 'Stunden',
  hour_one: 'Stunde',
  hour_other: 'Stunden',
  day: 'Tag',
  day_one: 'Tag',
  day_other: 'Tage',
  start_date: 'Startdatum',
  end_date: 'Enddatum',
  from_date: 'Ab Datum',
  to_date: 'Bis Datum',
  avg_from_date: 'Durchschnittliches Ab-Datum',
  avg_to_date: 'Durchschnitt bis heute',
  period: 'Zeitraum',
  description: 'Beschreibung',
  date: 'Datum',
  number: 'Nummer',
  apply: 'Anwenden',
  update: 'Aktualisieren',
  create: 'Erstellen',
  delete: 'Löschen',
  export: 'Exportieren',
  rssi: 'rssi',
  ber: 'ber',
  reading: 'Messwert',
  model: 'Modell',
  email_address: 'E-Mail-Addresse',
  password: 'Passwort',
  confirm_password: 'Passwort wiederholen',
  sign_in: 'Einloggen',
  graph: 'Diagramm',
  no_data: 'Keine Daten',
  every: 'Jeden',
  for_company: 'Für die firma',
  flow: 'Durchfluss',
  no_data_found: 'Keine Daten gefunden.',
  percent: 'Prozent',
  device_number_devicenum: 'Device number: {{device_number}}',
  device_number: 'Gerätenummer',
  device_name: 'Gerätename',
  successfully_saved: 'Erfolgreich gespeichert',
  error_occured: 'Es ist ein Fehler aufgetreten',
  none: 'Keine',
  off: 'Aus',
  no_unit: 'Keine Maßeinheit',
  software_version: 'Software-Version',
  hardware_version: 'Hardware-Version',
  transmission_period: 'Übertragungsintervall',
  record_period: 'Messintervall',
  replacement_number: 'Ersatznummer',
  replaced_by: 'Ersetzt durch',

  createdOn: 'Erstellt am',
  createdBy: 'Erstellt von',

  show_average: 'Durchschnitt anzeigen',
  show_readings: 'Messwerte anzeigen',

  yes: 'Ja',
  no: 'Nein',
  capital_yes: 'JA',
  capital_no: 'NEIN',

  sensor: 'Sensor',

  all_sensors: 'Alle Sensoren',

  select_all: 'Wählen Sie Alle',
  deselect_all: 'Abwählen',

  function_last: 'Last',
  function_first: 'First',
  function_avg: 'Average',
  function_min: 'Min',
  function_max: 'Max',
  function_median: 'Median',
  function_count: 'Count',
  function_last_flow: 'Last Flow',
  function_first_flow: 'First Flow',
  function_avg_flow: 'Average Flow',
  function_max_flow: 'Max Flow',
  function_min_flow: 'Min Flow',
  function_median_flow: 'Median Flow',

  page_title_header_number_with_name_absent: '{{title}} - {{device_number}}',
  page_title_header_number_with_name_present: '{{title}} - {{device_name}} ({{device_number}})',

  error_forbidden_operation_not_allowed: 'Nicht erlaubt',

  not_set: 'Nicht gesetzt',

  // Sensor Types
  generic_analog_sensor: 'Generischer analoger Sensor',
  generic_virtual_sensor: 'Generischer virtueller Sensor',
  generic_digital_sensor: 'Allgemeiner Digitaler Sensor',
  modbus_generic_analog_sensor: 'Modbus Allgemeiner Analoger Sensor',
  modbus_generic_digital_sensor: 'Modbus Allgemeiner Digitaler Sensor',
  pressure_sensor: 'Drucksensor',
  temperature_sensor: 'Temperatursensor',
  humidity_sensor: 'Feuchtigkeitssensor',
  level_sensor: 'Niveausensor',
  weight_meter: 'Gewichtsmesser',
  weight_sensor: 'Gewichtssensor',
  load_cells: 'Lastzellen',
  wind_direction_sensor: 'Windrichtungsensor',
  barometric_pressure_sensor: 'Barometrischer Drucksensor',
  soil_moisture_sensor: 'Bodenfeuchtesensor',
  dew_point_sensor: 'Taupunkt-Sensor',
  soil_temperature_sensor: 'Bodentemperatursensor',
  soil_potential_sensor: 'Bodenpotentialsensor',
  particulate_matter_sensor: 'Sensor für Partikelmatter',
  leaf_wetness_sensor: 'Blattfeuchtesensor',
  gnss_sensor: 'GNSS-Sensor',
  water_meter: 'Wasserzähler',
  power_meter: 'Stromzähler',
  gas_flow_meter: 'Gasdurchflussmesser',
  rain_sensor: 'Regensensor',
  wind_speed_sensor: 'Windgeschwindigkeitssensor',
  heat_meter: 'Wärmezähler',
  geiger_mueller_counter: 'Geiger-Müller-Zähler',
  on_off_sensor: 'Ein/Aus-Sensor',
  on_off_input_sensor: 'Ein/Aus-Eingangssensor',
  on_off_output_sensor: 'Ein/Aus-Ausgangssensor',
  on_off_auto_output_sensor: 'Ein/Aus/Automatik-Ausgangssensor',
  tasmota_relay_sensor: 'Tasmota-Relais-Sensor',
  modbus_generic_on_off_input_sensor: 'Modbus Allgemeiner Ein/Aus-Eingangssensor',
  modbus_generic_on_off_output_sensor: 'Modbus Allgemeiner Ein/Aus-Ausgangssensor',
  co_sensor: 'CO-Sensor',
  no2_sensor: 'NO2-Sensor',
  so2_sensor: 'SO2-Sensor',

  // Port Types
  digital_input_port: 'Digitaler Eingangsport',
  pulse_input_port: 'Impuls-Eingangsport',
  pulse_s0_input_port: 'S0 Impuls-Eingangsport',
  analog_input_port: 'Analoger Eingangsport',
  '4_20_mA_input_port': '4-20mA Eingangsport',
  '0_5_V_input_port': '0-5V Eingangsport',
  on_off_input_port: 'Ein/Aus Eingangsport',
  on_off_output_port: 'Ein/Aus Ausgangsport',
  generic_modbus_on_off_input_port: 'Modbus Allgemeiner Ein/Aus-Eingangsport',
  generic_modbus_on_off_output_port: 'Modbus Allgemeiner Ein/Aus-Ausgangsport',

  // duration
  duration_years_one: '{{count}} Jahr',
  duration_years_other: '{{count}} Jahre',
  duration_months_one: '{{count}} Monat',
  duration_months_other: '{{count}} Monate',
  duration_months_abbr: 'Mon.',
  duration_days_one: '{{count}} Tag',
  duration_days_other: '{{count}} Tage',
  duration_hours_one: '{{count}} Stunde',
  duration_hours_other: '{{count}} Stunden',
  duration_minutes_one: '{{count}} Minute',
  duration_minutes_other: '{{count}} Minuten',
  duration_seconds_one: '{{count}} Sekunde',
  duration_seconds_other: '{{count}} Sekunden',

  years: 'Jahre',
  months: 'Monate',
  days: 'Tage',

  /*
   * |===============|
   * | Period Picker |
   * |===============|
   */
  period_date_range: 'Datumsbereich',
  period_custom: 'Benutzerdefiniert',
  period_today: 'Heute',
  period_week: 'Woche',
  period_month: 'Monat',
  period_yesterday: 'Gestern',
  period_last_week: 'Letzten Woche',
  period_last_month: 'Letzten Monat',
  period_last_1_hours: 'Letzte Stunde',
  period_last_2_hours: 'Letzten 2 Stunden',
  period_last_4_hours: 'Letzten 4 Stunden',
  period_last_24_hours: 'Letzten 24 Stunden',
  period_last_48_hours: 'Letzten 48 Stunden',

  /*
   * |=====================|
   * | Hook Error Messages |
   * |=====================|
   */
  error_cannot_fetch_device: 'Gerät konnte nicht abgerufen werden.',
  error_cannot_fetch_device_config: 'Gerätekonfiguration konnte nicht abgerufen werden.',
  error_cannot_fetch_ports_config: 'Die Portkonfiguration konnte nicht abgerufen werden.',
  error_cannot_fetch_flow_stats: 'Datenflussstatistik konnte nicht abgerufen werden.',
  error_cannot_fetch_time_stats: 'Zeitstatistik konnte nicht abgerufen werden.',
  error_cannot_fetch_general_stats: 'Allgemeine Statistiken konnten nicht abgerufen werden.',
  error_cannot_fetch_qflow_stats: 'Qflow-Statistiken konnten nicht abgerufen werden.',

  signup_company_name: 'Firmenname',

  sign_up_form_first_name: 'Vorname',
  sign_up_form_last_name: 'Nachname',
  sign_up_form_email: 'E-Mail-Addresse',
  sign_up_form_password: 'Passwort',
  sign_up_form_confirm_password: 'Passwort wiederholen',
  sign_up_form_company_name: 'Firmenname',

  button_save: 'Speichern',
  button_apply: 'Anwenden',
  button_update: 'Aktualisieren',
  button_create: 'Erstellen',
  button_delete: 'Löschen',
  button_continue: 'Fortsetzen',
  button_back: 'Zurück',
  dashboard_tour_back: 'Zurück',
  dashboard_tour_next: 'Weiter',
  dashboard_tour_finish: 'Beenden',
  dashboard_tour_close: 'Schließen',
  dashboard_tour_open: 'Dialog öffnen',
  dashboard_tour_skip: 'Überspringen',
  dashboard_tour_next_with_progress: 'Weiter ({current} von {total})',
  capital_add_btn: 'ADDIEREN',
  capital_create_btn: 'SCHAFFEN',
  capital_update_btn: 'AKTUALISIEREN',
  capital_remove_btn: 'LÖSCHEN',
  capital_cancel_btn: 'ABBRECHEN',

  role_roles: 'Rollen',
  role_user: 'Benutzer',
  role_public: 'Öffentlichkeit',
  role_admin: 'Administrator',
  role_billing: 'Abrechnung',
  role_super_admin: 'Superadministrator',
  role_restricted: 'Eingeschränkt',

  device_counters_cumulative_graph_graph: 'Diagramm, Gerätenummer: {{device_number}}',
  device_counters_cumulative_graph_must_have_analog_sensor:
    'Muss einen aktivierten analogen Sensor haben.',

  sensor_statistics_min: 'Min.: {{min}}',
  sensor_statistics_max: 'Max.: {{max}}',
  sensor_statistics_avg: 'Mittel: {{avrg}}',
  sensor_statistics_total: 'Gesamt: {{total}}',

  chart_statistics_min: 'Min.:',
  chart_statistics_max: 'Max.:',
  chart_statistics_avg: 'Mittel:',
  chart_statistics_total: 'Gesamt:',

  menu_main: 'Übersicht',
  menu_device: 'Gerät',

  submenu_devices: 'Geräte',
  submenu_account: 'Konto',
  submenu_device_reports: 'Geräteberichte',
  submenu_settings: 'Einstellungen',

  link_selected_device: 'Ausgewähltes Gerät',
  link_device_nodes: 'Gerätenetz',
  link_devices: 'Geräteliste',
  link_accounts: 'Konten',
  link_utility_rate: 'Nutzungsrate',
  link_link_device: 'Gerät verknüpfen',
  link_create_user: 'Benutzer erstellen',
  link_icons: 'Ikonen',
  link_licenses: 'Lizenzen',
  link_accounts_manager: 'Konto erstellen',
  link_transmissions: 'Verbindungsprotokoll',
  link_map: 'Karte',
  link_inventory: 'Inventarliste',
  link_devices_manager: 'Geräte-Manager',
  link_battery: 'Batterie',
  device_groups: 'Gerätegruppen',
  link_signal: 'Signal',
  link_alarms: 'Alarme',
  link_value_ranges: 'Wertebereichsereignisse',
  link_device_account_lookup: 'Gerätekontosuche',
  link_show_users: 'Benutzer',
  link_dashboard: 'Dashboard',
  link_dashboard_2: 'Dashboard 2',
  link_reports: 'Berichte',
  link_scheduled_reports: 'Geplante Berichte',
  link_billing_report: 'Abrechnungsbericht',

  link_all_devices: 'Alle Geräte',
  link_readings: 'Messwerte',
  link_sensors_data: 'Sensordaten',
  link_flow: 'Durchfluss',
  link_graph: 'Diagramme',
  link_new_graph: 'Sofortige Grafik',
  link_pump_control: 'Pump Control',
  link_relay_control: 'Relay Control',
  link_alarm_config: 'Alarmkonfiguration',
  link_statistics: 'Statistik',
  link_customer: 'Metadaten',
  link_meter: 'Zähler',
  link_config: 'Konfigurationssynchronisierung',
  link_initial_config: 'Verbindungskonfiguration (alt)',
  link_sensor_config: 'Sensorkonfiguration (alt)',
  link_sensors_and_network_config: 'Parameterkonfiguration',
  link_export: 'Datenexport',
  link_customer_billing_report: 'Bericht zur Kundenabrechnung',
  link_flow_generator: 'Durchflussgenerator',
  link_commands: 'Befehle',
  link_copy_config: 'Konfig Kopieren',
  switch_to_new_menu_label: 'Neues Menü verwenden',
  switch_to_old_menu_label: 'Altes Menü verwenden',

  link_profile: 'Profil',
  link_language: 'Sprache',
  link_sign_out: 'Ausloggen',

  chip_early_access: 'Früher Zugang',

  pulse_sensor_1: 'Digitaler Sensor 1',
  pulse_sensor_2: 'Digitaler Sensor 2',
  analog_sensor_1: 'Analoger Sensor 1',
  analog_sensor_2: 'Analoger Sensor 2',
  analog_sensor_3: 'Analoger Sensor 3',
  analog_sensor_4: 'Analoger Sensor 4',
  analog_sensor_5: 'Sensor 1',
  analog_sensor_6: 'Sensor 2',
  analog_sensor_7: 'Sensor 3',
  analog_sensor_8: 'Sensor 4',
  on_off_sensor_1: 'Ein/Aus-Sensor 1',
  on_off_sensor_2: 'Ein/Aus-Sensor 2',
  on_off_sensor_3: 'Ein/Aus-Relais 1',
  on_off_sensor_4: 'Ein/Aus-Relais 2',

  device_icon: 'Gerätesymbol',
  sensor_icon: 'Sensorsymbol',
  icon_no_icon: 'Kein Symbol',
  icon_barometer: 'Barometer',
  icon_door_closed: 'Tür geschlossen',
  icon_door_open: 'Tür öffen',
  icon_electricity: 'Elektrizität',
  icon_energy_meter: 'Energiezähler',
  icon_gas_flow_meter: 'Gasdurchflussmesser',
  icon_gas: 'Gas',
  icon_generic_particle_meter: 'Generisches Partikelmessgerät',
  icon_generic: 'Generisch',
  icon_heat_meter: 'Wärmezähler',
  icon_humidity: 'Feuchtigkeit',
  icon_leaf_moisture: 'Blattfeuchtigkeit',
  icon_level_metering: 'Pegelmessung',
  icon_pivot: 'Drehpunkt',
  icon_pressure: 'Druck',
  icon_radiation: 'Strahlung',
  icon_rain: 'Regen',
  icon_soil_moisture: 'Bodenfeuchtigkeit',
  icon_temperature: 'Temperatur',
  icon_water_meter: 'Wasseruhr',
  icon_water: 'Wasser',
  icon_wind_direction: 'Windrichtung',
  icon_wind_speed: 'Windgeschwindigkeit',
  icon_pump: 'Pumpe',
  icon_apartment: 'Wohnhaus',
  icon_base_station: 'Basisstation',
  icon_clinic: 'Klinik',
  icon_hospital: 'Krankenhaus',
  icon_house: 'Haus',
  icon_mayor_office: 'Rathaus',
  icon_police_station: 'Polizeistation',
  icon_public_restroom: 'Öffentliches WC',
  icon_stadium: 'Stadion',
  icon_gas_station: 'Tankstelle',
  icon_controller: 'Steuerung',

  device_icon_new_portal: 'Symbol (neues Portal)',
  device_icon_old_portal: 'Symbol (altes Portal)',

  very_low_level_alarm: 'Alarm bei sehr niedrigem Füllstand',
  low_level_alarm: 'Alarm Pegelminimum',
  high_level_alarm: 'Alarm Pegelmaximum',
  very_high_level_alarm: 'Alarm bei sehr hohem Füllstand',

  sensor_conversion_formula: 'Sensor-Umwandlungsformel',
  delete_old_counters: 'Alte Berichte löschen',
  device_config_select_record_period: 'Zeitraum auswählen',
  device_config_select_transmission_period: 'Übertragungszeitraum auswählen',

  devices_table_number: 'Nummer',
  devices_table_name: 'Name',
  devices_table_device_number: 'Gerätenummer',
  devices_table_device_name: 'Gerätename',
  devices_table_business_partner: 'Geschäftspartner',
  devices_table_quarter: 'Quartal',
  devices_table_address: 'Adresse',
  devices_table_error: 'Geräte konnten nicht geladen werden',
  devices_table_no_devices_found: 'Keine Geräte gefunden',
  devices_table_description: 'Beschreibung',
  devices_column_header_search: 'Suche...',

  alarm_config_header: 'Alarme konfigurieren',
  alarm_config_notification_email: 'Benachrichtigungs-E-Mails',
  alarm_config_notification_email_place_holder: 'E-Mail-Liste (getrennt durch Komma)',
  alarm_config_missed_transmission_email: 'Verpasste Übertragung E-mails',
  alarm_config_missed_transmission_email_place_holder:
    'Verpasste Übertragung E-Mail-Liste (getrennt durch Komma)',
  alarm_config_high_consumption_threshold:
    'Maximalverbrauch für Übertragungsintervall {{transmission_every}} {{transmission_period}} [{{units}}]',
  alarm_config_low_flow_alarm_threshold: 'Alarmschwelle Durchfluss min. [{{units}}]',
  alarm_config_high_flow_alarm_threshold: 'Alarmschwelle Durchfluss max. [{{units}}]',
  alarm_config_non_zero_consumption_time_range: 'Nullverbrauchsmessung',
  alarm_config_high_low_flow_time_range: 'Zeitintervall für großen/kleinen Durchfluss',
  alarm_config_start_time: 'Startzeit',
  alarm_config_end_time: 'Endzeit',
  alarm_config_flow_calc_time_base: 'Zeitbasis für Durchflussberechnung',
  alarm_config_saved_msg: 'Alarmkonfiguration gespeichert.',
  alarm_config_email_validation_error:
    'Bitte geben Sie gültige E-Mail-Adressen ein, getrennt durch ein einzelnes Komma ohne Leerzeichen, mit maximal 255 Zeichen.',

  alarm_config_non_zero_consumption_time_range_error: 'Muss eine Startzeit und eine Endzeit haben',
  alarm_config_low_flow_severity: 'Schweregrad des niedrigen Durchflusses',
  alarm_config_high_flow_severity: 'Schweregrad des hohen Durchflusses',
  alarm_config_high_consumption_severity: 'Schweregrad des hohen Verbrauchs',
  alarm_config_all_zero_severity: 'Schweregrad des Nullverbrauchs',
  alarm_config_non_zero_consumption_severity: 'Schweregrad des Nicht-Null-Verbrauchs',
  alarm_config_on_off_severity: 'Ein-/Ausschalt-Schweregrad',

  alarms_title: 'Alarme',
  alarms_title_with_dev_num: 'Alarme, Gerätenummer: {{device_number}}',
  alarms_type: 'Alarmtyp',
  alarms_active_status: 'Aktivität',
  alarms_active_dropdown_label: 'Aktiv',
  alarms_inactive_dropdown_label: 'Inaktiv',

  device_battery_title: 'Batteriestatus',
  device_battery_voltage: 'Spannung, mV',
  device_battery_level: 'Pegel, %',

  device_signal_title: 'Signalstärke',

  device_counters_graph_header: 'Verbrauchsdiagramm',

  device_instant_graph_header: 'Sofortige Grafik',

  devices_signal_title: 'Signalqualität',
  devices_signal_level: 'Pegel',
  devices_signal_level_percent: 'Pegel, %',

  devices_battery_title: 'Batteriestatus',
  devices_battery_level: 'Batteriepegel, %',
  devices_battery_voltage: 'Spannung, mV',

  reports_export_title: 'Berichte exportieren',

  device_counter_export_title: 'Messwerte exportieren, Gerätenummer: {{device_number}}',

  device_config_record_and_transmission_period: 'Mess- und Übertragungsintervalle',
  device_config_record_period: 'Messintervall',
  device_config_transmission_period: 'Übertragungsintervall',
  device_config_start_setup: 'Setup übertragen',
  device_config_setup_message: 'Konfiguration gespeichert. Gerät mit Magnet aktivieren.',
  device_config_header: 'Gerät konfigurieren',
  device_config_config_date: 'Konfigurationsdatum: {{date}}',
  device_config_config_status: 'Status',
  device_config_config_status_configured: 'Synchronisiert',
  device_config_config_status_not_configured: 'Nicht synchronisiert',
  device_config_time_zone: 'Zeitzone',
  device_config_pulse_per: '{{x}} pro pulse',
  device_config_sensor_type: 'Sensorart',
  device_config_meter_type: 'Zählertyp',
  device_config_select_time_zone: 'Wähle Zeitzone aus',
  device_config_missed_transmission_alarm_severity:
    'Schwere der Alarmmeldung bei verpasster Übertragung',
  device_config_pulse_coef_not_changed_message:
    'Achtung: Der benutzerdefinierte "Impuls-Koeffizient" bleibt unverändert bei Änderungen des "Startwert"',
  device_config_does_not_support_this_model:
    'Dieses Gerätemodell wird auf dieser Seite nicht unterstützt.',

  device_digits_fraction: 'Nachkommastellen',
  device_digits_digits: 'Vorkommastellen',
  device_digits_initial_reading: 'Startwert',
  device_digits_alert_too_many_total_digits: 'Maximal 9 Ziffern möglich!',
  device_digits_alert_too_small_total_digits: 'Mindestens 4 Ziffern nötig!',
  device_digits_alert_too_many_total_fraction: 'Maximal 3 Nachkommastellen bzw. 9 Ziffern möglich!',
  device_digits_alert_too_small_total_fraction:
    'Anzahl der Nachkommastellen ist 0! (min. 4 Ziffern nötig)',

  device_transmissions_at: 'Übertragungsübersicht bis {{query_date}}',
  device_transmissions_last_transmission_short: 'Letzte Übertragung',
  device_transmissions_next_transmissions_short: 'Nächste Übertragung',
  device_transmissions_days: 'Tage',
  device_transmissions_transmissions_short: 'Übertragung',
  device_transmissions_count: 'Anzahl',
  device_transmissions_fail: 'Gescheitert',
  device_transmissions_customer: 'Kunde',
  device_transmissions_address: 'Adresse',
  device_transmissions_ok: 'Ok',

  link_device_link_device_to_my_account: 'Gerät mit meinem Konto verknüpfen',
  link_device_device_number: 'Gerätenummer',
  link_device_unlink_device: 'Gerät trennen',
  link_device_with_device_number: `Gerät verknüpfen: {{device_number}}`,
  unlink_device_with_device_number: `Gerät trennen: {{device_number}}`,
  link_device_devices_counts:
    'Verknüpfte Geräte: {{linked_devices_count}} / {{allowed_devices_count}}',
  link_device_success_message: 'Gerät erfolgreich verknüpft',
  unlink_device_success_message: 'Gerät erfolgreich entfernt von: ',
  link_device_enter_device_number_error: 'Geben Sie eine Gerätenummer ein',
  link_device_select_company_error: 'Wählen Sie ein Unternehmen',
  link_device_default_error: 'Es gab ein Problem beim Verknüpfen/Trennen des Geräts',
  link_device_company_not_found_error: 'Unternehmen nicht gefunden',
  link_device_device_not_found_error: 'Gerät {{device_number}} wurde nicht gefunden',
  link_device_device_not_linked_error: 'Gerät {{device_number}} ist nicht verknüpft',
  link_device_device_already_linked_error: 'Gerät {{device_number}} ist bereits verknüpft',
  link_device_device_limit_reached_error: 'Gerätelimit erreicht',
  link_device_operation_not_allowed_error: 'Operation nicht erlaubt',
  link_device_unlink_devices_for_sub_accounts: 'Gerät für alle Unterkonten trennen',
  link_device_unlink_devices_for_sub_accounts_tooltip:
    'Wenn ausgewählt, wird das Gerät vom ausgewählten und allen Unterkonten getrennt. Wenn nicht ausgewählt, wird das Gerät nur für das ausgewählte Konto getrennt.',
  link_device_lookup_title: 'Gerätesuche',
  link_device_lookup_subheader:
    'Klicken Sie auf eine Zeile in dieser Tabelle, um die Gerätenummer im Verknüpfungsformular automatisch auszufüllen.',
  link_device_lookup_filter_number: 'Nummer',
  link_device_lookup_filter_name: 'Name',
  link_device_lookup_device_name: 'Gerätename',
  link_device_lookup_device_number: 'Gerätenummer',
  link_device_lookup_no_devices_found: 'Keine Geräte gefunden',

  device_search_device_number: 'Gerätenummer',
  device_search_kicker: 'Unternehmenskontext',
  device_search_title: 'Unternehmenssuche nach Gerät',
  device_search_subtitle:
    'Suchen Sie nach einer Gerätenummer und wählen Sie das Unternehmen aus, das in Management aktiv bleiben soll.',
  device_search_device_number_placeholder: 'Gerätenummer eingeben',
  device_search_length_hint: 'Die Suche startet automatisch, sobald Sie mit dem Tippen aufhören.',
  device_search_clear: 'Löschen',
  device_search_selected_company: 'Ausgewähltes Unternehmen',
  device_search_selected_company_hint:
    'Klicken Sie erneut auf dieselbe Zeile, um die aktuelle Unternehmensauswahl aufzuheben.',
  device_search_error: 'Unternehmen für diese Gerätenummer konnten nicht geladen werden.',
  device_search_no_matches: 'Für diese Gerätenummer wurden keine Unternehmen gefunden.',
  device_search_results_title: 'Passende Unternehmen',
  device_search_results_ready:
    'Wählen Sie eine Zeile aus, um den aktiven Unternehmenskontext zu ändern.',
  device_search_results_waiting: 'Geben Sie eine Gerätenummer ein, um die Suche zu starten.',
  device_search_empty_prompt: 'Geben Sie eine Gerätenummer ein, um passende Unternehmen zu suchen.',
  device_search_empty_prompt_subtitle:
    'Die Ergebnisse werden hier angezeigt, sobald Sie mit dem Tippen aufhören.',
  device_search_domain: 'Domain',

  device_manager_create_or_delete_device: 'Gerät erstellen oder löschen: {{device_number}}',
  device_manager_device_number: 'Gerätenummer',
  device_manager_device_model: 'Gerätemodell',
  device_manager_sw_version_validation:
    'Das erforderliche Format ist X.X.X oder X.X.X- und X.X.X_ gefolgt von Zeichen, wobei X eine Zahl ist',
  device_manager_hw_version_validation: 'Das erforderliche Format ist X.X.X, wobei X eine Zahl ist',
  device_manager_software_version: 'Software-Version',
  device_manager_hardware_version: 'Hardware-Version',

  dashboard_alarms: 'Alarme',
  dashboard_batteries: 'Batteriestatus',
  dashboard_signal: 'Signalqualität',
  dashboard_transmission: '{{alarm_type}} ({{alarm_count}})',
  dashboard_chart_battery_level: 'Batterie Level',
  dashboard_chart_signal_level: 'Signalpegel',
  dashboard_chart_number_of_devices: 'Anzahl der Geräte',
  dashboard_select_company_header: 'Wählen Sie ein Konto, um das Dashboard anzuzeigen',
  dashboard_select_company_from: 'Von hier: ',
  dashboard_select_company_accounts_page_link: 'Konten',

  alarm_type_no_zero_consumption: 'Kein Nullverbrauch',
  alarm_type_high_consumption: 'Maximalverbrauch',
  alarm_type_high_flow: 'Durchfluss max.',
  alarm_type_missed_transmission: 'Verpasste Übertragung',
  alarm_type_low_flow: 'Durchfluss min.',
  alarm_type_all_zero_consumption: 'Nullverbrauch',
  alarm_type_device_removed: 'Gerät entfernt',
  alarm_type_on_off_alarm: 'Status',
  alarm_type_low_level: 'Pegel min.',
  alarm_type_high_level: 'Pegel max.',
  alarm_type_tamper: 'Manipulation',
  alarm_type_oversized: 'Übergroß',
  alarm_type_undersized: 'Untermaß',
  alarm_type_low_battery: 'Niedriger Batteriestatus',
  alarm_type_blockage: 'Blockierung',
  alarm_type_burst: 'Platzen',
  alarm_type_reverse_flow: 'Rückfluss',
  alarm_type_range_event: 'Bereichsereignis',
  alarm_type_very_low_level: 'Sehr Niedriger Füllstand',
  alarm_type_very_high_level: 'Sehr Hoher Füllstand',
  alarm_type_leakage: 'Leckage',
  alarm_type_low_temperature: 'Niedrige Temperatur',
  alarm_type_no_consumption: 'Kein Verbrauch',
  alarm_type_negative_flow: 'Negativer Durchfluss',
  alarm_type_empty_spool: 'Leeres Rohr',
  alarm_type_combination_of_alarms: 'Alarmkombination',
  alarm_type_standstill: 'Stillstand',
  alarm_type_reset_error: 'Reset-Fehler',
  alarm_type_rf_error: 'RF-Fehler',
  alarm_type_cs_error: 'CS-Fehler',
  alarm_type_measuring_error: 'Messfehler',
  alarm_type_reset_event: 'Reset-Ereignis',
  alarm_type_magnetic_field: 'Magnetfeld',
  alarm_type_sensor_fraud: 'Sensormanipulation',

  device_counter_graph_min: 'Min.: {{min}}',
  device_counter_graph_max: 'Max.: {{max}}',
  device_counter_graph_avg: 'Mittel: {{avrg}}',
  device_counter_graph_total: 'Gesamt: {{total}}',
  device_counter_graph_average: 'gemittelt:',
  device_counter_graph_no_data: 'Keine Daten',
  device_counter_graph_cant_calculate_flow_analog:
    'Für analoge Sensor kann kein Durchfluss berechnet werden!',
  device_counter_graph_must_have_digital_sensor: 'Muss einen aktivierten digitalen Sensor haben.',

  customer_info_header: 'Kundendaten',
  customer_info_business_partner_number: 'Geschäftspartnernummer',
  customer_info_contact_data: 'Kontaktdaten',
  customer_info_contract_number: 'Vertragsnummer',
  customer_info_name: 'Name',
  customer_info_description: 'Beschreibung',
  customer_info_billing_group: 'Fakturierungsgruppe',
  customer_info_municipality: 'Ort',
  customer_info_quarter: 'Bezirk',
  customer_info_street: 'Straße',
  customer_info_block: 'Häuserblock',
  customer_info_entr: 'Eingang',
  customer_info_customer_type: 'Kundentyp',
  customer_info_customer_type_commercial: 'Kommerziell',
  customer_info_customer_type_domestic: 'Inländisch',
  customer_info_customer_type_block_of_flats: 'Wohnblock',
  customer_info_customer_type_budget: 'Budget',

  meter_info_meter_info: 'Zählerdaten: {{device_number}}',
  meter_info_factory_number: 'Seriennummer',
  meter_info_brand: 'Marke',
  meter_info_enter_diameter: 'Nenndurchmesser',
  meter_info_mount_date: 'Montagedatum',
  meter_info_meter_info_saved: 'Zählerdaten gespeichert.',

  device_initial_config_header: 'Verbindungskonfiguration',
  device_initial_device_model: 'Gerätemodell',
  device_initial_config_address: 'Adresse',
  device_initial_config_port: 'Port',
  device_initial_config_resolve_address: 'Adresse auflösen (DNS verwenden)',
  device_initial_config_simcard_provider: 'Sim-Karten-Anbieter',
  device_initial_config_simcard_number: 'Sim-Karten-Nummer',
  device_initial_config_bands: 'bands',
  device_initial_config_OTAA_appkey: 'OTAA - appkey',
  device_initial_config_OTAA_deveui: 'OTAA - deveui',
  device_initial_config_OTAA_appeui: 'OTAA - appeui',
  device_initial_config_ABP_appskey: 'ABP - appskey',
  device_initial_config_ABP_nwkskey: 'ABP - nwkskey',
  device_initial_config_ABP_devaddr: 'ABP - devaddr',
  device_initial_config_ABP_deveui: 'ABP - deveui',
  device_initial_config_lora_app_mode: 'App-Modus',
  device_initial_config_app_id: 'App-ID',
  device_initial_config_profile_id: 'Profil-ID',
  device_initial_config_platform_name: 'Plattformname',
  device_initial_config_thingslog_lora_platform: 'ThingsLog LoRa-Plattform',
  device_receive_data_binary: 'Daten binär empfangen',
  device_send_data_binary: 'Daten binär senden',
  device_mqtt_config: 'MQTT Konfig',
  device_mqtt_config_qos: 'Servicequalität',
  device_mqtt_config_username: 'Benutzername',
  device_mqtt_config_password: 'Passwort',
  device_mqtt_config_certificate: 'Zertifikat',
  device_initial_config_apn_username: 'APN-Benutzername',
  device_initial_config_apn_password: 'APN-Passwort',
  device_initial_config_net_attached_delay: 'Übertragungsverzögerung',
  device_initial_config_gprs_radio_mode: 'GPRS-Radiomodus',
  device_initial_config_grps_radio_mode_auto_option: 'Automatisch',
  device_initial_config_preferred_network_type: 'Bevorzugter Netzwerktyp',
  device_initial_config_preferred_network_default_option: 'Standard',
  device_initial_config_mcc_mnc: 'MCC-MNC',
  device_initial_config_slave_devices: 'Slave-Geräte',
  device_initial_config_modbus_address: 'Modbus-Adresse',
  device_initial_config_modbus_master_device: 'Master-Gerätenummer',
  device_initial_config_trashcan_brand: 'Marke',
  device_initial_config_trashcan_model: 'Modell',
  device_initial_config_trashcan_volume: 'Volumen',
  device_initial_config_trashcan_max_weight: 'Maximales Gewicht',
  device_initial_config_trashcan_material: 'Material',
  device_initial_config_trashcan_color: 'Farbe',
  device_initial_config_trashcan_waste_type: 'Abfalltyp',
  device_initial_config_trashcan_waste_type_plastic: 'Kunststoff',
  device_initial_config_trashcan_waste_type_bio: 'Bio',
  device_initial_config_trashcan_waste_type_paper: 'Papier',
  device_initial_config_trashcan_waste_type_glass: 'Glas',
  device_initial_config_trashcan_waste_type_metal: 'Metall',
  device_initial_config_trashcan_waste_type_mixed: 'Gemischt',
  device_initial_config_trashcan_waste_type_other: 'Andere',
  device_initial_config_trashcan_pricing: 'Preisgestaltung',
  device_initial_config_trashcan_pricing_free: 'Kostenlos',
  device_initial_config_trashcan_pricing_per_lift: 'Pro Abholung',
  device_initial_config_trashcan_pricing_per_kg: 'Pro Kilogramm',
  device_initial_config_trashcan_pricing_per_subscription: 'Pro Abonnement',
  device_initial_config_trashcan_placement: 'Platzierung',
  device_initial_config_trashcan_placement_on_the_street: 'Auf der Straße',
  device_initial_config_trashcan_placement_inside: 'Innen',
  device_initial_config_trashcan_placement_backyard: 'Hof',
  device_initial_config_trashcan_customer_community_id: 'Kunden-Community-ID',
  device_initial_config_trash_truck_brand: 'Marke',
  device_initial_config_trash_truck_plate_number: 'Kennzeichen',
  device_initial_config_trash_truck_model: 'Modell',
  device_initial_config_find_encryption_key_by_device_number:
    'Schlüssel für Verschlüsselung durch Gerätenummer finden',

  sensor_config_header: 'Sensorkonfiguration',
  sensor_config_name: 'Name',
  sensor_config_sensor_name: 'Sensorname',
  sensor_config_sensor_icon: 'Symbolname',
  sensor_config_description: 'Beschreibung',
  sensor_config_model: 'Modell',
  sensor_config_serial_number: 'Seriennummer',
  sensor_config_manufacturer: 'Hersteller',
  sensor_config_diameter: 'Durchmesser',
  sensor_config_price: 'Preis',
  sensor_config_currency: 'Währung',
  sensor_config_supported_visualization_types: 'Unterstützte Visualisierungstypen',
  sensor_config_port_type: 'Porttyp',
  sensor_config_port_type_digital_input_port: 'Digitaler Eingang',
  sensor_config_port_type_analog_input_port: 'Analogeingang',
  sensor_config_port_type_pulse_s0_input_port: 'Pulse S0 Eingang',
  sensor_config_port_type_pulse_input_port: 'Impulseingang',
  sensor_config_port_type_on_off_input_port: 'Statuseingang',
  sensor_config_port_type_on_off_output_port: 'Statusausgang',
  sensor_config_port_conversion_formula: 'Port-Konvertierungsformel',
  sensor_config_formula: 'Formel',
  sensor_config_offset: 'Versetzt',
  sensor_config_sensor_index_tooltip: 'Sensorindex: {{sensor_index}}',
  sensor_config_visible: 'Sichtbarkeit',
  sensor_config_order_number: 'Bestellnummer',
  sensor_config_visible_true: 'Sichtbar',
  sensor_config_visible_false: 'Unsichtbar',
  sensor_config_use_in_sensor_aggregation: 'Verwendung in der Sensoraggregation',
  sensor_config_use_in_sensor_aggregation_true: 'Verwenden',
  sensor_config_use_in_sensor_aggregation_false: 'Nicht verwenden',
  sensor_config_value_labels: 'Wertbeschriftungen',
  sensor_config_label_for_value_zero: 'Beschriftung für den Wert "0"',
  sensor_config_label_for_value_one: 'Beschriftung für den Wert "1"',
  sensor_config_inverted_read_state_value: 'Invertierter Lesezustand',
  sensor_config_inverted_read_state_value_true: 'Invertiert',
  sensor_config_inverted_read_state_value_false: 'Nicht invertiert',
  sensor_config_register_address: 'Registeradresse',
  sensor_config_data_type: 'Datentyp',
  sensor_config_count: 'Anzahl',
  sensor_config_number_registers: 'Anzahl Register',
  sensor_config_particle_size: 'Partikelgröße',
  sensor_config_power: 'Leistung',
  sensor_config_measurement_type: 'Messart',
  sensor_config_measurement_group: 'Messgruppe',
  tasmota_generic_digital_sensor: 'Tasmota generischer digitaler Sensor',
  tasmota_alarm_input_sensor: 'Tasmota Alarm-Eingangs-Sensor',
  tasmota_generic_analog_sensor: 'Tasmota generischer analoger Sensor',

  device_counter_statistics_statistics_id:
    'Statistik, Gerätenummer: {{device_number}}, {{description}}',
  device_counter_statistics_quarter: 'Quartal',
  device_counter_statistics_flow: 'Durchfluss',
  device_counter_statistics_hour: 'Stunde',
  device_counter_statistics_quantity: 'Menge',
  device_counter_statistics_value: 'Wert',
  device_counter_statistics_digital_ports_must_be_present:
    'Sie müssen einen Impulseingang an einen Wasserzähler Sensor angeschlossen haben, um diese Tabelle sehen zu können.',
  device_counter_statistics_name_must_have_initialized_value:
    'Die Parameter Q3, R und Durchmesser sind am Impulseingang erforderlich, der an einen Wasserzählersensor angeschlossen ist.',

  company_manager_title: 'Konto erstellen oder löschen: {{company_name}}',
  company_manager_account_name: 'Kontobezeichnung',
  company_manager_solution: 'Art des Projekts',
  company_manager_solution_option_none: 'Nicht zugewiesen',
  company_manager_solution_option_agri: 'Agrarisch',
  company_manager_solution_option_air_quality: 'Saubere Luft',
  company_manager_solution_option_street_lights: 'Straßenbeleuchtung',
  company_manager_solution_option_pump_station: 'Pumpstation',
  company_manager_solution_option_smart_waste: 'Smart Waste',
  company_manager_solution_option_level: 'Pegelüberwachung',
  company_manager_solution_option_gas: 'Gasüberwachung',
  company_manager_solution_option_pressure: 'Drucküberwachung',
  company_manager_solution_option_smart_water: 'Smart Water',
  company_manager_solution_option_environment_monitoring: 'Umweltüberwachung',
  company_manager_solution_option_energy: 'Energieüberwachung',
  company_manager_license: 'Lizenz',
  company_manager_account: 'Konto',
  company_manager_create_company: 'Konto erstellen',
  company_manager_create_company_error: 'Es gab ein Problem bei der Erstellung Ihres Kontos',
  company_manager_license_info_box:
    'Das Hinzufügen einer Lizenz erfordert eine gültige Kontonummer. Überprüfen Sie Ihre Kontonummer, wenn Sie sie in den Erstellungsprozess einbeziehen möchten.',
  company_manager_valid_from: 'Gültig von',
  company_manager_valid_to: 'Gültig bis',
  company_manager_solution_type: 'Lösungstyp',
  company_manager_contact_id: 'Kontakt-ID',
  company_manager_account_id: 'Konto-ID',
  company_manager_license_type: 'Lizenztyp',
  company_manager_timezone: 'Zeitzone',
  company_manager_country: 'Land',
  company_manager_countries_error: 'Länder konnten nicht geladen werden',
  company_manager_timezones_error: 'Zeitzonen konnten nicht geladen werden',
  company_manager_account_info: 'Kontoinformationen',
  company_manager_address: 'Adresse',
  company_manager_city: 'Stadt',
  company_manager_municipality: 'Gemeinde',
  company_manager_area: 'Bereich',
  company_manager_zip_code: 'Postleitzahl',
  company_manager_vat_number: 'Umsatzsteuer-Identifikationsnummer',
  company_manager_account_ext_number: 'Externe Kontonummer',
  company_manager_account_ext_type: 'Externer Kontotyp',
  company_manager_account_ext_type_none: 'Keine',
  company_manager_account_ext_type_household: 'Haushalt',
  company_manager_account_ext_type_business: 'Geschäft',

  company_manager_license_per_device: 'Pro Gerät',
  company_manager_license_per_reading: 'Pro Bericht',
  company_manager_license_per_sensor: 'Pro Sensor',
  company_manager_license_per_poc: 'Pro Proof of Concept (POC)',
  company_manager_license_per_remote_node: 'Pro Remote-Knoten',

  company_manager_creating_account: 'Konto erstellen: {{company_name}}',
  company_manager_deleting_account: 'Konto löschen: {{company_name}}',
  company_manager_account_created: 'Konto erfolgreich erstellt!',
  company_manager_account_deleted: 'Konto erfolgreich gelöscht!',

  company_manager_update_company: 'Konto aktualisieren',
  company_manager_delete_company: 'Konto löschen',
  company_manager_actions: 'Aktionen',
  company_manager_delete_modal_description:
    'Sind Sie sicher, dass Sie dieses Konto löschen wollen, denn die Aktion ist nicht umkehrbar?',
  company_manager_confirm_button: 'Bestätigen',
  company_manager_cancel_button: 'Abbrechen',
  company_manager_delete_company_error_message:
    'Beim Löschen des Kontos ist ein Fehler aufgetreten',
  company_manager_update_btn: 'Aktualisieren',
  company_manager_child_company_warning_message: 'Erstellen eines Unterkontos von',
  company_manager_current_logged_in_company: 'das Konto, bei dem Sie gerade angemeldet sind',
  company_manager_current_selected_company: 'das Konto, das Sie gerade ausgewählt haben',
  accounts_child_companies: 'Unterkonten',
  accounts_contactRef: 'Kontakt-ID',
  accounts_externalNumber: 'Externe Nummer',
  accounts_accountRef: 'Konto-ID',
  accounts_logo: 'Logo',
  accounts_info_unavailable: 'Keine Unternehmensinformationen fur dieses Konto verfugbar.',
  company_manager_accountRef_is_disabled_because_of_license_type:
    'Konto-ID ist deaktiviert, da es sich um eine POC-Lizenz handelt',
  accounts_none: 'Keine',
  company_manager_update_company_success: 'Konto erfolgreich aktualisiert',
  company_manager_update_company_error: 'Beim Aktualisieren des Kontos ist ein Fehler aufgetreten',
  company_manager_account_name_exists: 'Ein Konto mit diesem Namen existiert bereits.',

  license_manager_title: 'Lizenz aktualisieren: {{company_name}}',
  license_manager_license: 'Lizenz',
  license_manager_license_updated: 'Lizenz aktualisiert',

  companies_title: 'Anzahl der Konten: {{company_number}}',
  companies_table_name: 'Name',
  companies_number_of_accounts: 'Anzahl der Konten:',
  companies_search: 'Suche',

  users_title: 'Benutzer',
  units_type: 'Einheitensystem',

  reports_export_format_type: 'Format',

  login_form_forgot_password: 'Passwort vergessen?',

  pump_auto_every: 'Auto every {{secs}} secs',
  pump_svg_last_updated: 'Last updated: {{timestamp}}',
  pump_svg_power_supply: 'Power Supply',
  pump_svg_water_level_controller: 'Water Level Controller',
  pump_svg_pump: 'Pump',
  pump_svg_level_sensor: 'Level Sensor',
  pump_svg_pump_on_sensor: 'Pump-on Sensor',
  pump_svg_pump_off_sensor: 'Pump-off Sensor',
  pump_svg_dry_run_sensor: 'Dry Run Sensor',

  device_groups_error_please_select_company: 'Bitte wählen Sie ein Unternehmen aus.',

  device_groups_btn_add: 'Hinzufügen',
  device_groups_btn_edit: 'Bearbeiten',
  device_groups_btn_delete: 'Löschen',
  device_groups_btn_cancel: 'Abbrechen',
  device_groups_tooltip_edit: 'Bearbeiten',
  device_groups_tooltip_delete: 'Löschen',
  device_groups_color_picker_label: 'Gerätegruppen farbe',

  device_groups_name: 'Name',
  device_groups_devices: 'Geräte',
  device_groups_view_devices: '{{count}} Geräte anzeigen',
  device_groups_group_name: 'Gruppenname',
  device_groups_parent_device_group: 'Übergeordnete Gerätegruppe',
  device_groups_auto_device_group_type_label: 'Automatische Gerätegruppe',
  device_groups_auto_device_group_type_none: 'Keine automatische Gruppe',
  device_groups_auto_device_group_type_all_devices: 'Alle Geräte',
  device_groups_auto_device_group_type_all_water: 'Alle Wassergeräte',
  device_groups_auto_device_group_type_all_energy: 'Alle Energiegeräte',
  device_groups_auto_device_group_type_all_pressure: 'Alle Drucksensoren',
  device_groups_auto_device_group_type_all_barometric_pressure: 'Alle Barometerdrucksensoren',
  device_groups_auto_device_group_type_all_levels: 'Alle Füllstandsensoren',
  device_groups_auto_device_group_type_all_soil_moisture: 'Alle Bodenfeuchtesensoren',
  device_groups_auto_device_group_type_all_air_humidity: 'Alle Luftfeuchtesensoren',
  device_groups_auto_device_group_type_all_temperatures: 'Alle Temperatursensoren',
  device_groups_auto_device_group_type_all_pm10: 'Alle PM10-Sensoren',
  device_groups_auto_device_group_type_all_pm2_5: 'Alle PM2.5-Sensoren',
  device_groups_auto_device_group_type_unknown: 'Unbekannte automatische Gruppe',
  device_groups_auto_device_group_alert_title: 'Automatische Gerätegruppe aktiviert',
  device_groups_auto_device_group_alert_description: 'Diese Gruppe ist als {{type}} konfiguriert.',
  device_groups_auto_device_group_change: 'Ändern',
  device_groups_auto_device_group_change_modal_title: 'Automatische Gerätegruppe ändern',
  device_groups_menuitem_none: 'Keiner',
  device_groups_add_device_group: 'Gerätegruppe hinzufügen',
  device_groups_edit_device_group: 'Gerätegruppe bearbeiten',
  device_groups_delete_device_group: 'Gerätegruppe löschen',

  device_grous_add_sensor_device: 'Sensor und Gerät zur Gruppe hinzufügen',

  device_groups_table_sensor_group_name_header: 'Name der Sensorgruppe',
  device_groups_table_parent_group_name_header: 'Name der übergeordneten Gruppe',
  device_groups_table_device_count_header: 'Anzahl der Geräte',

  device_groups_sensor_table_device_number_header: 'Gerätenummer',
  device_groups_sensor_table_sensor_name_header: 'Name des Sensors',
  device_groups_sensor_table_sensor_index_header: 'Sensor-Index',
  device_groups_sensor_table_select_message: 'Auswählen einer Sensorgruppe',

  device_groups_sensors_add_modal_device_placeholder: 'Gerätenummer',
  device_groups_sensors_add_modal_sensor_placeholder: 'Sensor',
  device_groups_sensors_add_modal_device_group_name_required:
    'Der Name der Gerätegruppe ist erforderlich',

  device_groups_sensors_delete_description:
    'Wenn Sie diese Konfiguration löschen, wird sie dauerhaft vom Server entfernt.',
  device_groups_device_group_delete_description:
    'Wenn Sie die Gerätegruppe löschen, wird sie dauerhaft vom Server entfernt.',

  device_groups_select_company_header: 'Wählen Sie ein Unternehmen aus, um fortzufahren',
  device_groups_select_company_from: 'Von hier aus: ',
  device_groups_select_company_accounts_page_link: 'Kontoseite',

  device_groups_create_device_group_error:
    'Beim Erstellen einer neuen Gerätegruppe ist ein Problem aufgetreten',
  device_groups_update_device_group_error:
    'Beim Aktualisieren der Gerätegruppe ist ein Problem aufgetreten',
  device_groups_delete_device_group_error:
    'Beim Löschen der Gerätegruppe ist ein Problem aufgetreten',
  device_groups_add_device_sensor_device_group_error:
    'Beim Hinzufügen des Sensors ist ein Problem aufgetreten',
  device_groups_remove_device_sensor_device_group_error:
    'Beim Entfernen des Sensors ist ein Problem aufgetreten',

  /*
   * |==============|
   * | Users Config |
   * |==============|
   */

  //Page
  users_header: 'Benutzer',
  users_table_username: 'Nutzername',
  users_table_first_name: 'Vorname',
  users_table_last_name: 'Nachname',
  users_table_company_name: 'Konto',
  users_table_email: 'E-Mail',
  //Filters
  users_filter_username: 'Filtern Nutzername',
  users_filter_first_name: 'Filtern Vorname',
  users_filter_last_name: 'Filtern Nachname',
  users_filter_email: 'Filtern Email',
  users_filter_company_name: 'Filtern Konto',
  users_reset_filter_icon: 'Filter zurücksetzen',
  users_table_is_contact_person: 'Kontaktperson',

  //Modals
  users_add_modal_header: 'Benutzer Hinzufügen',
  users_update_modal_header: 'Benutzer Aktualisieren',
  user_remove_modal_icon: 'Benutzer löschen',
  users_remove_modal_header: 'Sind Sie sicher, dass Sie den Benutzer löschen möchten {{username}}',
  users_remove_modal_body:
    'Wenn Sie auf Entfernen klicken, wird der ausgewählte Benutzer dauerhaft vom Server gelöscht.',
  users_is_dashboard_enabled: 'Dashboard Aktivieren',
  users_is_contact_person: 'Kontaktperson',

  //Errors
  users_password_match: 'Passwörter stimmen nicht überein',
  users_email_blank: 'Email darf nicht leer sein',
  users_load_error: 'Benutzer konnten nicht geladen werden',
  users_update_error: 'Benutzer konnte nicht aktualisiert werden',
  users_delete_error: 'Benutzer konnte nicht gelöscht werden',
  users_create_error: 'Benutzer konnte nicht erstellt werden',

  // Success
  users_update_success: 'Benutzer erfolgreich aktualisiert',
  users_delete_success: 'Benutzer erfolgreich gelöscht',
  users_create_success: 'Benutzer erfolgreich erstellt',
  /*
   * |=====================|
   * | Value Ranges Config |
   * |=====================|
   */

  // Buttons & tooltips
  value_ranges_btn_add: 'Hinzufügen',
  value_ranges_btn_defaults: 'Standardwerte',
  value_ranges_line_color: 'Linienfarbe',
  value_ranges_node_color: 'Knotenfarbe',
  value_ranges_foreground_color: 'Vordergrundfarbe',
  value_ranges_background_color: 'Hintergrundfarbe',
  value_ranges_loading: 'Laden...',
  value_ranges_nothing_to_show: 'Nichts zu zeigen',

  //Page
  value_ranges_header: 'Wertebereichsereignisse',
  value_ranges_trigger: 'Auslösen',
  value_ranges_notifications: 'Benachrichtigungen',
  value_ranges_before: 'Vor',
  value_ranges_after: 'Nach',
  value_ranges_disabled: 'Аusgeschaltet',
  value_ranges_date_range: 'Datumsbereich',
  value_ranges_daily_time_slot: 'Tägliches Zeitfenster',
  value_ranges_timezone: 'Zeitzone',

  //Modals
  value_ranges_add_event: 'Ereignis hinzufügen',
  value_ranges_edit_event: 'Ereignis bearbeiten',
  value_ranges_add_default_events: 'Standardereignisse hinzufügen',
  value_ranges_remove_modal_header: 'Möchten Sie den Wertebereich wirklich löschen',
  value_ranges_remove_modal_body:
    'Durch Klicken auf Entfernen wird der ausgewählte Wertebereich dauerhaft gelöscht',

  //Form
  value_range_form_name: 'Veranstaltungsname',
  value_range_form_function: 'Funktion',
  value_range_form_sensor: 'Sensor',
  value_range_form_description: 'Beschreibung',
  value_range_form_min: 'Min',
  value_range_form_max: 'Max',
  value_range_form_severity: 'Schweregrad',
  value_range_form_start_day: 'Starttag',
  value_range_form_start_month: 'Monat starten',
  value_range_form_start_time: 'Startzeit',
  value_range_form_end_day: 'Endtag',
  value_range_form_end_month: 'Monat beenden',
  value_range_form_end_time: 'Endzeit',
  value_range_form_enable_events: 'Ereignisse aktivieren?',
  value_range_form_select_color: 'Ausgewählte Farbe',
  value_range_form_notification_email: 'Email',
  value_range_form_notification_push_notification: 'Push-Benachrichtigung',
  value_range_form_notification_sms: 'SMS',
  value_range_form_notification_push: 'Push-Benachrichtigung',
  value_range_form_notification_call: 'Forderung',
  value_range_form_line_custom_color: 'Benutzerdefinierte Linienfarbe',
  value_range_form_marker_custom_color: 'Benutzerdefinierte Markierungsfarbe',
  value_range_form_no_notifications: 'Keine Benachrichtigungen',

  //Errors

  value_range_tooltip_severity:
    'Schweregrad, der größer als 7 ist, wird als schwerwiegend angesehen. Schwere Ereignisse werden durch ein Ausrufezeichen gekennzeichnet.',
  value_range_error_add: 'Ereignis konnte nicht hinzugefügt werden',
  value_range_error_edit: 'Ereignis konnte nicht bearbeitet werden',
  value_range_name_is_required: 'Name ist erforderlich',
  value_range_name_already_exists:
    'Ereignisname existiert bereits für dieses Gerät und diesen Sensor',
  value_range_name_incorect_time: 'Falsches Zeitformat',
  value_range_min_greater_than_max: 'Min kann nicht größer als Max sein',
  value_range_min_equal_to_max: 'Min kann nicht gleich Max sein',
  value_range_min_max_is_required: 'Min oder Max ist erforderlich',
  value_range_error_occured: 'Es ist ein Fehler aufgetreten',
  value_range_start_incorrect_time:
    'Startzeit hat falsches Format. Es sollte HH:mm sein. Richtig: 01:00. Falsch: 1:00.',
  value_range_end_incorrect_time:
    'Endzeit hat falsches Format. Es sollte HH:mm sein. Richtig: 01:00. Falsch: 1:00.',
  value_range_start_day_missing_start_month: 'Starttag sollte Startmonat haben',
  value_range_end_day_missing_end_month: 'Endtag sollte Endmonat haben',
  value_range_start_month_missing_start_day: 'Der Startmonat sollte einen Starttag haben',
  value_range_end_month_missing_end_day: 'Der Endmonat sollte einen Endtag haben',
  value_range_mixed_alphabets_error:
    'Gemischte Alphabetnutzung festgestellt, bitte nur eine Sprache verwenden',

  /*
   * |==========|
   * | Commands |
   * |==========|
   */

  // Command State
  commands_command_state_pending: 'Ausstehend',
  commands_command_state_sent: 'Gesendet',
  commands_command_state_cancelled: 'Abgebrochen',
  commands_command_state_status_ok: 'OK',
  commands_command_state_status_nok: 'Nicht OK',
  commands_command_state_unknown: 'Unbekannt',
  commands_command_state_timeout: 'Zeitüberschreitung',

  // Command Type
  commands_command_type_relay_switch: 'Relaisschalter',
  commands_command_type_single_relay_switch: 'Einfacher Relaisschalter',
  commands_command_type_relay_switch_with_delay: 'Relaisschalter mit Verzögerung',
  commands_command_type_relay_statuses: 'Status der Relais',
  commands_command_type_send_config_over_mqtt: 'Konfiguration über MQTT senden',
  commands_command_type_send_date_over_mqtt: 'Datum über MQTT senden',
  commands_command_type_modbus: 'Modbus',
  commands_command_type_tasmota_relay_switch: 'Tasmota Relaisbefehl',
  commands_command_type_reset: 'Zurücksetzen',
  commands_command_type_scheduled_relay_command: 'Geplanter Relaisbefehl',
  commands_command_type_scheduled_relay_command_4: 'Geplante Relais-Befehle (4)',

  // Errors
  commands_error_missing_device_number: 'Device Number missing or wrong.',

  // Buttons
  commands_btn_send_command: 'Send Command',
  commands_btn_refresh: 'Aktualisieren',
  commands_btn_submit: 'Submit',

  // Tooltips
  commands_tooltip_edit: 'Edit',

  // Popups
  commands_send_command: 'Send Command',
  commands_edit_command: 'Edit Command',
  commands_command_type: 'Command Type',
  commands_parameters: 'Parameters',
  commands_parameter_name: 'Parameter Name',
  commands_parameter_value: 'Parameter Value',

  // Page
  commands_header: 'Commands',
  commands_type: 'Type',
  commands_status: 'Status',
  commands_relay_1_status: 'Relay 1 Status',
  commands_relay_2_status: 'Relay 2 Status',
  commands_created: 'Created',
  commands_sent: 'Sent',
  commands_executed: 'Executed',
  commands_relay_status: 'Relaisstatus',
  commands_relay_index: 'Relaisindex',

  commands_sensor_index: 'Sensorindex',
  commands_slave_device_number: 'Slave-Gerätenummer',
  commands_hour: 'Stunde',
  commands_minutes: 'Minuten',
  commands_auto_refresh: 'Automatische Aktualisierung',
  commands_no_commands: 'An dieses Gerät wurden noch keine Befehle gesendet.',
  commands_no_parameters: 'Dieser Befehl benötigt keine Parameter.',
  commands_no_parameter_values: 'Für dieses Gerät sind keine Werte verfügbar.',
  commands_schedule_group: 'Zeitplan {{index}}',
  commands_cancel_command: 'Befehl abbrechen',
  commands_cancel_command_confirm:
    'Dieser Befehl wurde noch nicht gesendet. Ein Abbruch verhindert die Zustellung an das Gerät.',
  commands_cancel_command_success: 'Befehl abgebrochen',
  commands_send_command_success: 'Befehl gesendet',
  commands_btn_close: 'Schließen',
  commands_btn_keep: 'Beibehalten',
  commands_parameters_empty: 'Keine Parameter',
  commands_command_id: 'ID',
  commands_error_send_failed: 'Der Befehl konnte nicht gesendet werden.',
  commands_error_cancel_failed: 'Der Befehl konnte nicht abgebrochen werden.',
  commands_error_parameters_failed: 'Die Parameter für diesen Befehl konnten nicht geladen werden.',
  commands_only_pending_can_be_cancelled: 'Nur ausstehende Befehle können abgebrochen werden.',
  commands_last_updated: 'Aktualisiert um {{time}}',
  commands_error_list_failed: 'Die Befehle konnten nicht geladen werden.',
  commands_range_hint: 'Zulässig: {{min}}–{{max}}',

  /*
   * |=============|
   * | Copy Config |
   * |=============|
   */

  // Page

  copy_config_copy_config: 'Konfig Кopieren',
  copy_config_to_device_number_with_name_absent: 'Zum Gerät: {{device_number}}',
  copy_config_to_device_number_with_name_present: 'Zum Gerät: {{device_name}} ({{device_number}})',
  copy_config_from_device_number: 'Von Gerätenummer',
  copy_config_copy_config_type_label: 'Konfigurationstyp kopieren',
  copy_config_existing_device_option: 'Bestehendes Gerät',
  copy_config_new_device_option: 'Neues Gerät',
  copy_config_should_copy_label: 'Soll kopiert werden:',
  copy_config_should_copy_config_option: 'Konfiguration',
  copy_config_should_copy_value_ranges_option: 'Wertebereiche',

  // Buttons
  copy_config_btn_copy: 'Kopieren',

  //Toast
  copy_config_toast_copied_success: 'Gerätekonfiguration erfolgreich kopiert.',
  copy_config_toast_copied_error: 'Es gab ein Problem beim Kopieren der Gerätekonfiguration.',
  copy_config_value_ranges_toast_copied_success: 'Wertebereiche wurden erfolgreich kopiert.',
  copy_config_value_ranges_toast_copied_error:
    'Es gab ein Problem beim Kopieren der Wertebereiche.',

  /*
   * |============|
   * | Statistics |
   * |============|
   */
  statistics_header: 'Statistik',
  statistics_header_hours: 'Std',
  statistics_header_quantity: 'Menge',
  statistics_header_value: 'Wert',
  statistics_quantity_minimum: 'Minimum',
  statistics_quantity_maximum: 'Maximal',
  statistics_quantity_average: 'Durchschnitt',
  statistics_quantity_total: 'Gesamt',
  statistics_quantity_hours: 'Std',
  statistics_quantity_counters: 'Zähler',
  statistics_error_title: 'Statistiken nicht verfügbar',
  statistics_error_missing_config_title: 'Die Wassermesserkonfiguration ist unvollständig',
  statistics_error_missing_config_description:
    'Um die Statistiken zu berechnen, müssen Durchmesser, q3 und r für jeden Wassermesser definiert sein. Prüfen Sie die aktuellen Werte unten und ergänzen Sie die fehlenden.',
  statistics_error_missing_field: '{{field}} fehlt',
  statistics_error_not_defined: 'Nicht definiert',
  statistics_error_open_sensor_config: 'Sensorkonfiguration öffnen',
  statistics_error_update_values_hint:
    'Ergänzen Sie die fehlenden Werte und kehren Sie dann zu dieser Seite zurück.',
  statistics_error_contact_admin:
    'Bitte wenden Sie sich an einen Administrator und bitten Sie ihn, die fehlenden Konfigurationswerte des Wassermessers zu definieren.',
  statistics_error_flow_unit_not_configured:
    'Für den ausgewählten Sensor ist keine Durchflusseinheit konfiguriert.',

  // Error
  statistics_error_definition_for_q3:
    'Sensor {{name}} enthält eine Definition für q3. Bitte besuchen Sie die Sensorkonfigurationsseite.',
  statistics_eror_definition_for_diameter:
    'Sensor {{name}} enthält eine Definition für diameter. Bitte besuchen Sie die Sensorkonfigurationsseite.',
  statistics_error_definition_for_r:
    'Sensor {{name}} enthält eine Definition für r. Bitte besuchen Sie die Sensorkonfigurationsseite.',
  statistics_error_no_water_meters_found:
    'Keine Wasserzähler gefunden. Bitte besuchen Sie die Gerätekonfigurationsseite.',

  /*
   * |=====|
   * | Map |
   * |=====|
   */
  map_add_device: '{{device}} hinzufügen',
  map_edit_device: '{{device}} bearbeiten',
  map_lat: 'Breite',
  map_long: 'Längengrad',
  map_coordinates: 'Koordinaten',
  map_polygon: 'Vieleck',
  map_linked_in_polygons: 'In Polygonen enthalten:',
  map_loading: 'Wird geladen...',

  // Button
  map_btn_link_device: 'Link-Gerät',
  map_btn_submit: 'Einreichen',

  // Error
  map_err_add_device_to_map: 'Gerät konnte nicht zur Karte hinzugefügt werden.',
  map_err_change_location: 'Ort konnte nicht geändert werden.',
  map_err_link_polygon: 'Verbindung zum Polygon konnte nicht hergestellt werden.',

  // Device Modal
  map_btn_get_curr_location: 'Aktuellen Standort abrufen',
  map_geolocation_not_supported: 'Geolocation wird nicht unterstützt.',
  map_lat_validation_message: 'Ungültiger Breitengrad',
  map_long_validation_message: 'Ungültiger Längengrad',
  map_invalid_location: 'Ungültiger Standort',
  map_invalid_coordinate_input:
    'Ungültige Koordinateneingabe. Es sollte „lat, long“ lauten, z.B. 42.123, 23.123',

  // Set Coordinates Modal
  map_coordinates_modal_btn_label: 'Koordinaten setzen',
  map_coordinates_modal_title: 'Koordinaten setzen',
  map_coordinates_modal_target_option_self: 'Für Selbst',
  map_coordinates_modal_target_option_company: 'Für Unternehmen',
  map_coordinates_modal_target_option_user: 'Für Benutzer',
  map_coordinates_modal_select_user_autocomplete_label: 'Benutzername',
  map_coordinates_modal_save_for_self_warning_message:
    'Das Speichern setzt die aktuellen Koordinaten als Standard für Ihren aktuellen Benutzer. Sind Sie sicher, dass Sie fortfahren möchten?',
  map_coordinates_modal_save_for_company_warning_message:
    'Das Speichern setzt die aktuellen Koordinaten als Standard für jeden Benutzer in Ihrem Unternehmen. Sind Sie sicher, dass Sie fortfahren möchten?',
  map_coordinates_modal_save_for_user_warning_message:
    'Das Speichern setzt die aktuellen Koordinaten als Standard für den ausgewählten Benutzer. Sind Sie sicher, dass Sie fortfahren möchten?',
  map_coordinates_modal_confirm_btn_label: 'Bestätigen',
  map_coordinates_modal_cancel_btn_label: 'Abbrechen',

  /*
   * |===============|
   * | Sensor Config |
   * |===============|
   */

  flow_time_units: 'Zeiteinheit',
  flow_measurement_units: 'Maßeinheit',
  flow_configuration_label: 'Flow-Konfiguration',
  flow_coefficient: 'Koeffizient',
  sensor_config_sensor_group_name: 'Name der Sensorgruppe',
  flow_configuration_alert_message:
    'Überprüfen Sie die folgenden Flow-Konfigurationen:\n{{message}}',
  flow_configuration_invalid_sensor_row_message:
    'Index: {{sensor_index}} with name: {{sensor_name}}\n',
  flow_configuration_sensor_name_not_set_label: 'Nicht eingestellt',

  /*
   * |===================|
   * | Device Prediction |
   * |===================|
   */
  device_prediction: 'Gerätevorhersage',
  device_prediction_header: 'Zeitreihenanalyse',
  device_prediction_sensor_name: 'Sensorname',
  device_prediction_forward_days: 'Voraussichtliche Tage',
  device_prediction_backward_days: 'Rückwärtige Tage',
  device_prediction_generate_btn: 'Erzeugen',
  device_prediction_error: 'Fehler',
  device_prediction_error_msg_json:
    'Beim Generieren von Vorhersagedaten ist ein Problem aufgetreten',
  device_prediction_error_msg_image:
    'Beim Erstellen des Vorhersagebilds ist ein Problem aufgetreten',
  device_prediction_date: 'Datum',
  device_prediction_trend: 'Trend',
  device_prediction_time: 'Zeit',
  device_prediction_legend_prediction: 'Vorhersage',
  device_prediction_legend_range: 'Vorhersagebereich',
  device_prediction_legend_consumption: 'Aktueller Verbrauch',
  device_prediction_help_title: 'Hilfe',
  device_prediction_help_title_input_guide: 'Eingabeanleitung',
  device_prediction_help_input_guide_text:
    '<strong> 1. Zeitraum </strong> - Benutzer können einen Zeitraum aus vordefinierten Optionen auswählen oder einen benutzerdefinierten Bereich festlegen. Das System analysiert die Daten innerhalb dieses gewählten Zeitraums, um zukünftige Vorhersagen zu berechnen und wertvolle Erkenntnisse zu liefern. <br> <strong> 2. Sensorname </strong> – wählen Sie den Sensor aus, dessen zukünftige Vorhersagen angezeigt werden sollen. <br> <strong> 3. Jede/r/s </strong> - wird für detailliertere Vorhersagen hinsichtlich der Granularität der Zeit verwendet. <br> <strong> 4. Vorwärtstage </strong> - Anzahl der Tage, für die der Benutzer zukünftige Vorhersagen treffen möchte. Diese Vorhersagen erstrecken sich über den ausgewählten Zeitraum hinaus und geben Einblicke in das erwartete Konsumverhalten. <br> <strong> 5. Rückwärtstage </strong> - stellt die Anzahl der Tage dar, die im Diagramm und in der Tabelle angezeigt werden sollen und die vom letzten Tag des ausgewählten Zeitraums an beginnen. Dies zeigt die historischen Echtdaten, die während dieses angegebenen Zeitraums vom Gerät empfangen wurden. <br> <strong> 6. Generieren-Schaltfläche </strong> – Wenn Sie auf "Generieren" klicken, berechnet das System den Verbrauch auf Grundlage der ausgewählten Einstellungen und generiert Vorhersagen. Die Ergebnisse werden dann sowohl in der Diagrammansicht als auch in der Tabellenansicht angezeigt. <br> <strong> 7. Diagramm </strong> – Das Diagramm zeigt sowohl die Vorwärts- als auch die Rückwärtstage an und präsentiert die tatsächlich empfangenen Daten sowie die vorhergesagten Daten. <br> <strong> 8. Tabelle </strong> - Die Tabelle zeigt alle Daten vom "von Periode" bis zum Ende der "Vorwärtstage". Jede Zeile enthält ein bestimmtes Datum, eine bestimmte Uhrzeit und den entsprechenden Trendwert, der die allgemeine Richtung oder das Muster der Daten im Laufe der Zeit angibt. Es hilft zu verstehen, ob die Werte während des vorhergesagten Zeitraums steigen, fallen oder stabil bleiben.',
  device_prediction_help_title_legend: 'Legende',
  device_prediction_help_black:
    '<strong> Schwarze Farbe </strong> - stellt die tatsächlichen Verbrauchsdaten während des ausgewählten Zeitraums dar (Beispiel: vom 01. Juli bis 31. Juli).',
  device_prediction_help_red:
    '<strong> Rote Farbe </strong> - Stellt den tatsächlichen Verbrauch dar, wenn Daten außerhalb des ausgewählten Zeitraums vorhanden sind. Auf dem obigen Bild gibt es echte Daten, die von dem Gerät in den Tagen empfangen wurden, für die das Modell Vorhersagen trifft. Der Benutzer kann daher die vorhergesagten Werte (dunkelblau) mit den roten (echten Daten) vergleichen.',
  device_prediction_help_dark_blue:
    ' <strong> Dunkelblaue Farbe </strong> - stellt die Vorhersage für den ausgewählten Zeitraum dar, die alte Daten enthält und sich mit den vorhergesagten Werten der Vorwärtstage in die Zukunft erstreckt. Diese Vorhersagen bieten Einblicke in den erwarteten Konsumtrend.',
  device_prediction_help_light_blue:
    '<strong> Hellblaue Farbe </strong> - stellt den Bereich der vorhergesagten Werte dar. Es zeigt an, dass die tatsächlichen Verbrauchsdaten innerhalb dieses Bereichs liegen könnten und deutet auf die mit Vorhersagen verbundene Unsicherheit hin.',
  device_prediction_help_example:
    "Wenn das 'VON'-Datum auf den 1. Juli und das 'BIS'-Datum auf den 31. Juli festgelegt sind, mit 'Vorwärtstagen' von 30, 'Rückwärtstagen' von 30 und 'JEDE' von 10 Minuten, zeigt das Diagramm den 30-tägigen tatsächlichen Verbrauch (vom 1. Juli bis 1. August) und die vorhergesagten Werte für 30 Tage nach vorne (vom 1. August bis 1. September). Die Tabelle zeigt den tatsächlichen und vorhergesagten Verbrauch für jede 10-minütige Zeitspanne vom 1. Juli bis zum 1. September 2023.",

  /*
   * |=================|
   * | Counters Export |
   * |=================|
   */

  // Buttons and dropdowns
  counters_export_header: 'Daten exportieren',
  counters_readings_header: 'Berichte',
  counters_export_search: 'Suche',
  counters_export_download: 'Herunterladen',
  counters_export_format: 'Format',

  // Table columns
  counters_export_table_device_name: 'Gerätename',
  counters_export_table_device_number: 'Gerätenummer',
  counters_export_table_sensor_index: 'Sensorindex',
  counters_export_table_sensor_name: 'Sensorname',
  counters_export_table_date: 'Datum',
  counters_export_table_counters: 'Wert',
  counters_export_table_prev_counters: 'Vorheriger Wert',
  counters_export_table_dt: 'Zeitdifferenz',
  counters_export_table_delta: 'Differenz',
  counters_export_error_alert_message: 'Beim Generieren der Daten ist ein Fehler aufgetreten.',
  counter_export_select_devices_label: 'Geräte auswählen',
  counter_export_select_sensors_label: 'Sensoren auswählen',
  counter_export_sensor_index: 'Sensorindex: {{sensor_index}}',

  counters_export_maximum_capacity_error_message: 'Maximale Exportkapazität erreicht!',
  counters_export_maximum_capacity_suggestion_message:
    'Bitte verringern Sie die Anzahl der ausgewählten Geräte oder den Datumszeitraum.',
  counters_export_empty_selection_title: 'Wählen Sie aus, was exportiert werden soll',
  counters_export_empty_selection_message:
    'Wählen Sie ein oder mehrere Geräte oder Gerätegruppen aus, um den Export der Messwerte vorzubereiten.',
  counters_export_ready_title: 'Auswahl bereit',
  counters_export_ready_message:
    '{{devicesCount}} Geräte und {{groupsCount}} Gerätegruppen wurden ausgewählt. Klicken Sie auf Suchen, um die Daten anzuzeigen, oder auf Herunterladen, um sie zu exportieren.',
  counters_export_selected_device_toast: 'Ausgewähltes Gerät: {{deviceNumber}}',
  /*
   * |====================|
   * | Consumption Export |
   * |====================|
   */

  // Buttons and dropdowns
  consumption_export_header: 'Bericht',
  consumption_export_search: 'Suche',
  consumption_export_download: 'Herunterladen',
  consumption_export_format: 'Format',
  consumption_export_aggregation_period: 'Aggregationszeitraum',
  consumption_export_aggregation_options_none: 'Keiner',
  consumption_export_aggregation_options_daily: 'Täglich',
  consumption_export_aggregation_options_weekly: 'Wöchentlich',
  consumption_export_aggregation_options_monthly: 'Monatlich',
  consumption_export_aggregation_options_yearly: 'Jährlich',

  // Table columns
  consumption_export_table_device_number: 'Gerätenummer',
  consumption_export_table_sensor_index: 'Sensorindex',
  consumption_export_table_address: 'Adresse',
  consumption_export_table_sensor_name: 'Sensorname',
  consumption_export_table_first_reading_date: 'Datum des ersten Werts',
  consumption_export_table_first_reading_value: 'Erster Wert',
  consumption_export_table_last_reading_date: 'Datum des letzten Werts',
  consumption_export_table_last_reading_value: 'Letzter Wert',
  consumption_export_table_delta: 'Differenz',
  consumption_export_table_average: 'Durchschnitt',
  consumption_export_table_consumption_for_period: 'Verbrauch für den Zeitraum',
  consumption_export_empty_selection_title: 'Wählen Sie aus, was exportiert werden soll',
  consumption_export_empty_selection_message:
    'Wählen Sie ein oder mehrere Geräte oder Gerätegruppen aus, um den Verbrauchsexport vorzubereiten.',
  consumption_export_ready_title: 'Auswahl bereit',
  consumption_export_ready_message:
    '{{devicesCount}} Geräte und {{groupsCount}} Gerätegruppen wurden ausgewählt. Klicken Sie auf Suchen, um die Daten anzuzeigen, oder auf Herunterladen, um sie zu exportieren.',
  consumption_export_selected_device_toast: 'Ausgewähltes Gerät: {{deviceNumber}}',

  /*
   * |=================|
   * | Alarms Export |
   * |=================|
   */

  // Buttons and dropdowns
  alarms_export_header: 'Alarm',
  alarms_export_search: 'Suchen',
  alarms_export_refresh: 'Aktualisieren',
  alarms_export_download: 'Herunterladen',
  alarms_export_format: 'Format',

  alarms_return_to_alarms: 'Zurück zu Alarme',
  alarms_redirect_to_graph: 'Weiterleitung zu Diagramm',

  // Table columns
  alarms_export_table_date: 'Datum',
  alarms_export_table_device_number: 'Gerätenummer',
  alarms_export_table_device_name: 'Gerätename',
  alarms_export_table_severity: 'Schweregrad',
  alarm_severity_tooltip: 'Schweregrad: {{value}} von 10',
  alarm_severity_none_tooltip: 'Kein Schweregrad für diesen Alarm gemeldet',
  alarms_export_table_sensor_index: 'Sensorindex',
  alarms_export_table_sensor_name: 'Sensorname',
  alarms_export_table_alarm_type: 'Typ',
  alarms_export_table_alarm_status: 'Status',
  alarms_export_table_description: 'Beschreibung',
  alarms_export_table_link_to_graph: 'Link zum Diagramm',
  alarms_export_chip_status_active: 'Aktiv',
  alarms_export_chip_status_inactive: 'Inaktiv',
  alarms_export_switch_title_label: 'Automatische Aktualisierung',
  alarms_export_error_alert_message: 'Beim Generieren der Daten ist ein Fehler aufgetreten.',
  alarms_export_select_company_alert_message:
    'Wählen Sie ein Unternehmen aus, bevor Sie Alarme abrufen',
  alarms_export_select_device_or_company_alert_message:
    'Wählen Sie ein Gerät oder eine Firma aus, bevor Sie Alarme abrufen',
  alarms_export_error_too_big_query:
    'Das Abrufen des Verlaufs von Superadministrator für alle Geräte ist eine zu große Anforderung. Bitte wählen Sie ein Unternehmen aus.',

  /*
   * |================|
   * | Inventory page |
   * |================|
   */

  //table
  device_inventory_page_header: 'Inventarliste',
  device_inventory_column_header_search: 'Suche...',
  device_inventory_description: 'Beschreibung',
  device_inventory_device_name: 'Gerätename',
  device_inventory_device_number: 'Gerätenummer',
  device_inventory_hardware_version: 'Hardware-Version',
  device_inventory_model: 'Modell',
  device_inventory_software_version: 'Software-Version',
  device_inventory_actions: 'Aktionen',
  nomenclature: 'Nomenklatur',

  //modal
  device_inventory_manual: 'Manuell',
  device_inventory_template: 'Vorlage',
  device_inventory_add_device: 'Gerät hinzufügen',
  device_inventory_create_device_button: 'Gerät erstellen',
  device_inventory_delete_unlink_modal_body:
    'Dies wird das ausgewählte Gerät dauerhaft löschen oder Sie können es von dem ausgewählten Unternehmen trennen. Das Gerät wird vom aktuellen Konto und allen Unterkonten getrennt. Wenn Sie das Gerät nur vom aktuellen Konto trennen möchten, besuchen Sie bitte die Seite "Gerät verknüpfen".',
  device_inventory_delete_modal_body: 'Dies wird das ausgewählte Gerät dauerhaft löschen.',
  device_inventory_hardware_version_helper:
    'Das erforderliche Format lautet X.X.X, wobei X eine Zahl ist',
  device_inventory_update_device_button: 'Gerät aktualisieren',
  device_inventory_update_device_title: 'Aktualisierung {{number}}',
  device_inventory_modal_delete_device_title: 'Gerät löschen {{number}}',
  device_inventory_software_version_helper:
    'Das erforderliche Format lautet X.X.X oder X.X.X- und X.X.X_ gefolgt von Zeichen, wobei X eine Zahl ist',
  device_inventory_description_helper: 'Beschreibungslänge erreicht',
  device_inventory_device_number_helper:
    'Bitte geben Sie 8 Zeichen ein, die nur Buchstaben (A-Z) und Zahlen (0-9) enthalten.',
  device_inventory_modal_select_action: 'Aktion für Gerät {{deviceNumber}} auswählen',
  device_inventory_reference_device_number: 'Gerät auswählen',
  device_inventory_nomenclature_required_for_model:
    'Die Nomenklatur ist erforderlich für {{model}}',

  //success
  device_inventory_create_device_success: 'Gerät erfolgreich erstellt',
  device_inventory_update_device_success: 'Gerät erfolgreich aktualisiert',
  device_inventory_delete_device_success: 'Gerät erfolgreich gelöscht',
  device_inventory_unlink_device_success: 'Gerät erfolgreich getrennt',
  device_inventory_rma_add_success: 'RMA-Eintrag erfolgreich hinzugefügt',
  device_inventory_rma_history_title: 'RMA-Verlauf - {{number}}',
  device_inventory_rma_add_record: 'Eintrag hinzufügen',
  device_inventory_rma_no_records: 'Keine RMA-Einträge für dieses Gerät',
  device_inventory_rma_add_error: 'Beim Hinzufügen des RMA-Eintrags ist ein Fehler aufgetreten',
  rma_record_date: 'Datum',
  rma_record_date_required: 'Datum ist erforderlich',
  rma_record_type: 'Typ',
  rma_record_category: 'Kategorie',
  rma_record_comments: 'Kommentare',
  rma_record_save: 'Speichern',
  rma_record_back: 'Zurück',
  rma_type_INCIDENT: 'Vorfall',
  rma_type_DEVICE_EVENT: 'Geräteereignis',
  rma_type_RMA: 'RMA',
  rma_category_BATTERY_REPLACEMENT: 'Batteriewechsel',
  rma_category_SIM_CARD_CHANGE: 'SIM-Kartenwechsel',
  rma_category_ENCLOSURE_DEGRADATION: 'Gehäusedegradation',
  rma_category_FLOOD_DAMAGE: 'Wasserschaden',
  rma_category_ANTENNA_REPLACEMENT: 'Antennenwechsel',
  rma_category_POWER_SUPPLY_PROBLEM: 'Stromversorgungsproblem',
  rma_category_PHYSICAL_DAMAGE: 'Physischer Schaden',
  rma_category_STOLEN: 'Gestohlen',
  rma_category_WRONG_CONFIGURATION: 'Falsche Konfiguration',
  rma_category_OTHER: 'Sonstiges',

  //error
  device_inventory_create_device_error: 'Beim Erstellen des Geräts ist ein Fehler aufgetreten',
  device_inventory_delete_device_error: 'Beim Löschen des Geräts ist ein Fehler aufgetreten',
  device_inventory_device_exists: 'Gerät existiert bereits',
  device_inventory_empty_device_error: 'Gerätenummer darf nicht leer sein',
  device_inventory_empty_reference_error: 'Gerät auswählen',
  device_inventory_empty_device_name_error: 'Gerätename darf nicht leer sein',
  device_inventory_empty_hardware_error: 'Hardware-Version darf nicht leer sein',
  device_inventory_empty_software_error: 'Software-Version darf nicht leer sein',
  device_inventory_error: 'Geräte konnten nicht geladen werden',
  device_inventory_update_device_error: 'Beim Aktualisieren des Geräts ist ein Fehler aufgetreten',
  device_inventory_already_exists_error: 'Gerät mit dieser Nummer existiert bereits',
  device_inventory_empty_nomenclature_error: 'Die Nomenklatur darf nicht leer sein',
  device_inventory_empty_manufacturing_date_error: 'Herstellungsdatum darf nicht leer sein',
  device_inventory_empty_warranty_period_error: 'Garantiezeitraum darf nicht leer sein',

  /*
   * |====================|
   * | Transmissions page |
   * |====================|
   */

  //page
  transmissions_page_title: 'Übertragungen',
  transmissions_page_refresh: 'Aktualisieren',
  transmissions_page_export_csv: 'In CSV exportieren',
  transmissions_page_error_message: 'Konnte Übertragungen nicht laden',

  //table
  transmissions_table_device_number: 'Gerätenummer',
  transmissions_table_device_name: 'Gerätename',
  transmissions_table_last_transmission: 'Letzte Übertragung',
  transmissions_table_next_transmission: 'Nächste Übertragung',
  transmissions_table_days: 'Tage',
  transmissions_table_transmission: 'Übertragung',
  transmissions_table_count: 'Anzahl',
  transmissions_table_customer: 'Kunde',
  transmissions_table_address: 'Adresse',
  transmissions_table_ok: 'OK',
  transmissions_table_devEUI: 'devEUI',
  transmissions_table_simcard_number: 'Sim-Karten-Nummer',
  transmissions_table_simcard_provider: 'Sim-Karten-Anbieter',
  transmissions_table_apn: 'APN',

  /*
   * |===============|
   * | Device Config |
   * |===============|
   */

  // page
  device_config_period: 'Zeitraum',
  device_config_every: 'Jeden',

  // error
  device_config_error_record_period_postiive: 'Der Aufzeichnungszeitraum muss positiv sein.',
  device_config_error_transmission_period_positive: 'Der Übertragungszeitraum muss positiv sein.',
  device_config_error_record_must_be_greater_than_transmission:
    'Der Aufzeichnungszeitraum darf nicht länger sein als der Übertragungszeitraum.',
  device_config_error_not_divisible:
    'Der Aufzeichnungszeitraum ist nicht durch den Übertragungszeitraum teilbar.',
  device_config_error_max_threshold_reached:
    '{{curr}} Datensätze pro Übertragung sind mehr als das Maximum {{max}}.',

  /*
   * |=======|
   * | Graph |
   * |=======|
   */
  graph_tabs_readings: 'Werte',
  graph_tabs_prediction: 'Vorhersage',
  graph_tabs_average: 'Durchschnitt',
  graph_tabs_previous: 'Vorherige',
  graph_column_sensor: 'Sensor',
  graph_column_index: 'Index',
  graph_column_device: 'Gerät',
  graph_column_device_name: 'Gerätename',
  graph_column_date: 'Datum',
  graph_column_readings: 'Wert',
  graph_column_previous_readings: 'Vorheriger Wert',
  graph_column_delta: 'Differenz',
  /*
   * |===============|
   * | Settings page |
   * |===============|
   */
  settings_page_header: 'Einstellungen',
  settings_submit_success_msg: 'Einstellungen gespeichert',
  settings_submit_error_msg: 'Einstellungen konnten nicht gespeichert werden',
  settings_input_invalid_format_error_msg: 'Ungültiges Datenformat',
  settings_certificate_not_found_error: 'Auf diesem Dateipfad wurde kein Zertifikat gefunden',
  settings_add_button: 'Hinzufügen',
  settings_submit_button: 'Einreichen',
  settings_input_key_label: 'Schlüssel',
  settings_input_type_label: 'Typ',
  settings_input_value_label: 'Wert',
  settings_select_type_string: 'Zeichenkette',
  settings_select_type_number: 'Zahl',
  settings_select_type_boolean: 'Boolesch',
  settings_select_type_object: 'Objekt',
  settings_logo_label: 'Logo',
  settings_dashboard_layout_label: 'Dashboard-Layout',
  settings_certificate_label: 'Zertifikatspfad',
  settings_device_panel_title: 'Geräte-Panel-Titel',
  settings_sensor_panel_title: 'Sensor-Panel-Titel',
  settings_header_home_label: 'Header-Startseite-Label (Portal)',
  settings_header_dashboard_label: 'Header-Dashboard-Label (Portal)',
  settings_footer_main_label: 'Fußzeilen-Hauptlabel (Portal)',
  settings_footer_link_label: 'Fußzeilen-Link-Label (Portal)',
  settings_footer_link_url: 'Fußzeilen-Link-URL (Portal)',
  settings_alarm_notification_display_period:
    'Alarmbenachrichtigungsanzeigezeitraum (Stunden) (Portal)',

  /* |===========|
   * | New Graph |
   * |===========|
   */

  //page
  new_graph_add_device_group_modal_title: 'Gerätegruppensensoren "Jede" Konfiguration',
  new_graph_add_device_group_modal_device_group: 'Gerätegruppe: ',
  new_graph_add_device_group_modal_sensors_to_add: 'Sensoren zum Hinzufügen: ',
  new_graph_add_device_group_modal_every_selector_mode_per_device: 'Pro Gerät',
  new_graph_add_device_group_modal_every_selector_mode_per_sensor: 'Pro Sensor',
  new_graph_add_device_group_modal_sensor_limit_message:
    'Sie können das Graphenlimit von {{graphSensorsLimit}} Sensoren nicht überschreiten!',
  new_graph_add_device_group_modal_confirm_button: 'Bestätigen',
  new_graph_add_device_group_modal_cancel_button: 'Abbrechen',
  new_graph_select_sensor_heading: 'Wählen Sie Sensor',
  new_graph_date_range_selection: 'Auswahl des Datumsbereichs',
  new_graph_selected_sensors_heading: 'Ausgewählte Sensoren',
  new_graph_selected_sensors_remove_all_tooltip: 'Alle löschen',
  new_graph_select_company_message: 'Bitte wählen Sie ein Unternehmen aus',
  new_graph_show_sensors_statistics_label: 'Statistik anzeigen',

  //sensor selection
  new_graph_device_group_label: 'Gerätegruppe',
  new_graph_device_label: 'Gerät',
  new_graph_sensor_label: 'Sensor',

  //date range selection
  new_graph_average_days_label: 'Tage im Durchschnitt',
  new_graph_time_series_prediction_period_label: 'Zeitraum',
  new_graph_auto_refresh_label: 'Aktualisieren',
  new_graph_period_picker_heading: 'Zeitraum',
  new_graph_average_days_heading: 'Durchschnitt',
  new_graph_time_series_prediction_period_heading: 'Zeitreihenvorhersage',
  new_graph_none_option: 'Keiner',
  new_graph_day_option_one: '{{count}} Tag',
  new_graph_day_option_other: '{{count}} Tage',
  new_graph_week_option_one: '{{count}} Woche',
  new_graph_week_option_other: '{{count}} Wochen',
  new_graph_month_option_one: '{{count}} Monat',
  new_graph_month_option_other: '{{count}} Monate',
  new_graph_year_option_one: '{{count}} Jahr',
  new_graph_year_option_other: '{{count}} Jahre',

  //tooltip
  new_graph_current_value_name: 'Aktuell',
  new_graph_average_value_name: 'Durchschnitt',
  new_graph_prediction_value_name: 'Prognose',

  //error
  new_graph_fetch_device_groups_error:
    'Die Gerätegruppen für das Unternehmen konnten nicht geladen werden.',
  new_graph_fetch_devices_error: 'Die Geräte für das Unternehmen konnten nicht geladen werden.',
  new_graph_fetch_device_config_error:
    'Die Konfiguration des ausgewählten Geräts konnte nicht geladen werden.',
  new_graph_fetch_device_ports_config_error:
    'Die Ports für das ausgewählte Gerät konnten nicht geladen werden.',
  new_graph_fetch_device_flow_error:
    'Der Fluss für das Gerät {{deviceName}} konnte nicht geladen werden.',
  new_graph_fetch_device_flow_avg_error:
    'Der durchschnittliche Fluss für das Gerät {{deviceName}} konnte nicht geladen werden.',
  new_graph_fetch_device_readings_error: 'Konnte die Messwerte für {{deviceName}} nicht laden.',
  new_graph_fetch_device_readings_avg_error:
    'Konnte die Durchschnittswerte für {{deviceName}} nicht laden.',
  new_graph_fetch_device_on_off_alarms_error:
    'Die Ein-/Aus-Alarms für {{deviceName}} konnten nicht geladen werden.',
  new_graph_fetch_device_prediction_error:
    'Die Vorhersage für {{deviceName}} konnte nicht geladen werden.',
  new_graph_sensor_already_in_state_error:
    'Dieser spezifische Sensor wurde bereits zur Liste hinzugefügt.',

  /* |================|
   * | Billing Report |
   * |================|
   */

  billing_report_header: 'Abrechnungsbericht',
  billing_report_btn_generate: 'Generieren',
  billing_report_device_number: 'Gerätenummer',
  billing_report_first_reading_date: 'Erstes Ablesedatum',
  billing_report_last_reading_date: 'Letztes Ablesedatum',
  billing_report_readings: 'Ablesungen',
  billing_report_battery: 'Batterie',
  billing_report_signal: 'Signal',
  billing_report_total: 'Gesamt',

  /* |================|
   * | Profile Page   |
   * |================|
   */
  profile_page_change_logo: 'Logo ändern',
  profile_page_logo_formats_message: 'Akzeptable Formate: PNG, JPEG',
  profile_page_name: 'Name',
  profile_page_email: 'E-Mail',
  profile_page_language: 'Sprache',
  profile_page_password: 'Passwort',
  profile_page_change_language: 'Sprache ändern',
  profile_page_update_license: 'Lizenz aktualisieren',
  profile_page_change_password: 'Passwort ändern',
  profile_page_generate: 'Erzeugen',
  profile_page_api_token: 'API-Token',
  profile_page_client_id: 'Client-ID',
  profile_page_client_secret: 'Client-Secret',
  profile_page_show_client_id: 'Client-ID anzeigen',
  profile_page_hide_client_id: 'Client-ID verbergen',
  profile_page_show_client_secret: 'Client-Secret anzeigen',
  profile_page_hide_client_secret: 'Client-Secret verbergen',
  profile_page_api_token_label: 'API-Token',
  profile_page_api_token_valid_for: 'Gültig für {{duration}}.',
  profile_page_copy: 'Kopieren',
  profile_page_copied_to_clipboard: 'In die Zwischenablage kopiert.',
  profile_page_failed_to_copy: 'Fehler beim Kopieren in die Zwischenablage.',
  profile_page_token_generated_success: 'Token erfolgreich generiert.',
  profile_page_token_generate_error: 'Fehler beim Generieren des Tokens.',
  profile_page_header: 'Profil',
  profile_page_user_info_label: 'Benutzerinformationen',
  profile_page_license_label: 'Lizenz ',
  profile_page_license_type: 'Lizenztyp',
  profile_page_valid_from: 'Gültig von',
  profile_page_valid_to: 'Gültig bis',
  profile_page_max_readings: 'Maximale Ablesungen',
  profile_page_current_count: 'Aktuelle Anzahl',
  profile_page_first_reading: 'Erste Ablesung',
  profile_page_last_reading: 'Letzte Ablesung',
  profile_page_license_status: 'Status',
  profile_page_renew_license_button: 'Lizenz erneuern',
  profile_page_deactivate_license_button: 'Lizenz deaktivieren',
  profile_page_valid_license: 'Gültige Lizenz',
  profile_page_invalid_license: 'Ungültige Lizenz',
  profile_page_deactivate_license_success_message: 'Lizenz deaktiviert.',
  profile_page_deactivate_license_error_message: 'Lizenz konnte nicht deaktiviert werden.',
  profile_page_deactivate_modal_title: 'Lizenzdeaktivierung',
  profile_page_confirm_button: 'Bestätigen',
  profile_page_cancel_button: 'Abbrechen',
  profile_page_deactivate_license_modal_description:
    'Sind Sie sicher, dass Sie diese Lizenz deaktivieren möchten?',
  profile_page_activate_license_modal_description:
    'Sind Sie sicher, dass Sie diese Lizenz aktivieren möchten?',
  profile_page_activate_modal_title: 'Lizenzaktivierung',
  profile_page_license_per_device: 'pro Gerät',
  profile_page_license_per_reading: 'pro Ablesung',
  profile_page_license_per_sensor: 'pro Sensor',
  profile_page_license_per_poc: 'pro Proof of Concept (POC)',
  profile_page_license_per_remote_node: 'pro Remote-Knoten',
  profile_page_license_partial: 'teilweise',
  profile_page_logo_file_format_error: 'Ungültiger Dateityp. Bitte laden Sie ein Bild hoch.',
  profile_page_logo_size_error:
    'Die Dateigröße überschreitet 1MB. Bitte laden Sie ein kleineres Bild hoch.',
  profile_page_version_info: 'Aktuelle Versionen:',
  profile_page_country: 'Land',
  profile_page_timezone: 'Zeitzone',
  profile_page_address: 'Adresse',
  profile_page_city: 'Stadt',
  profile_page_municipality: 'Gemeinde',
  profile_page_area: 'Bereich',
  profile_page_zip_code: 'Postleitzahl',
  profile_page_vat_number: 'Umsatzsteuer-Identifikationsnummer',
  profile_page_edit: 'Konto bearbeiten',
  profile_page_update_account_success: 'Konto erfolgreich aktualisiert',
  profile_page_license_info: 'Lizenzinformationen',

  logo_error_message: 'Unternehmenslogo konnte nicht geladen werden',
  /* |===============|
   * | Utility Rates |
   * |===============|
   */

  util_rates: 'Versorgungstarife',

  // table
  util_rates_name: 'Name',
  util_rates_price: 'Preis',
  util_rates_currency: 'Währung',
  util_rates_unit: 'Einheit',
  util_rates_private: 'Privat',
  util_rate_company: 'Unternehmen',
  util_rate_created: 'Erstellt',
  util_rates_updated: 'Aktualisiert',
  util_rates_actions: 'Aktionen',
  util_rates_tooltip_inspect: 'Prüfen',

  // modals
  util_rates_add_modal_header: 'Versorgungspreis hinzufügen',
  util_rates_edit_modal_header: 'Bearbeiten {{name}}',
  util_rates_delete_modal_header: 'Löschen {{name}}',
  util_rates_delete_modal_body: 'Dadurch wird der ausgewählte Versorgungstarif dauerhaft gelöscht',
  util_rates_confirm: 'Bestätigen',
  util_rates_cancel: 'Stornieren',
  util_rates_loading: 'Wird geladen...',
  util_rates_error: 'Fehler...',
  util_rates_error_name_exists: 'Name existiert bereits',

  // errors
  util_rate_fetch_company_error: 'Firmen konnten nicht geladen werden',
  util_rate_fetch_util_rates_error: 'Die Stromtarife konnten nicht geladen werden',

  // footer
  footer_powered_by: 'Unterstützt von',
  util_rates_name_required: 'Name ist erforderlich',
  util_rates_price_required: 'Preis ist erforderlich',

  /*
   * |=======|
   * | Icons |
   * |=======|
   */
  icon_type: 'Typ',
  icon_type_device: 'Gerät',
  icon_type_sensor: 'Sensor',

  icon_scope: 'Umfang',
  icon_scope_global: 'Global',
  icon_scope_company: 'Unternehmen',
  icon_scope_device: 'Gerät',
  icon_scope_sensor: 'Sensor',

  icon_input_device: 'Gerät',
  icon_input_sensor: 'Sensor',
  icon_input_name: 'Name',
  icon_input_company: 'Unternehmen',

  icon_btn_add_icon: 'Ikone hinzufügen',
  icon_btn_upload_file: 'Datei hochladen',
  icon_btn_cancel: 'Stornieren',
  icon_btn_save: 'Speichern',

  icon_table_name: 'Name',
  icon_table_scope: 'Umfang',
  icon_table_icon: 'Symbol',
  icon_table_actions: 'Aktionen',

  // errors
  icon_error_update_icon: 'Konnte das Symbol nicht aktualisieren',
  icon_error_unsupported_file_type: 'Ungültiger Dateityp. Nur JPEG, PNG und SVG sind erlaubt.',
  icon_error_error_occured: 'Ein Fehler ist aufgetreten',
  icon_error_enter_name: 'Bitte geben Sie einen Namen ein',
  icon_error_enter_icon: 'Bitte laden Sie ein Symbol hoch',
  icon_error_select_company: 'Bitte wählen Sie eine Firma aus',
  icon_error_select_device: 'Bitte wählen Sie ein Gerät aus',
  icon_error_select_sensor: 'Bitte wählen Sie einen Sensor aus',

  /*
   * |=========================|
   * | Customer Billing Report |
   * |=========================|
   */
  customer_billing_report_account_id_table_header: 'Konto-ID',
  customer_billing_report_description_table_header: 'Beschreibung',
  customer_billing_report_customer_name_table_header: 'Kundenname',
  customer_billing_report_street_table_header: 'Straße',
  customer_billing_report_quarter_table_header: 'Quartal',
  customer_billing_report_last_reading_table_header: 'Letzte Ablesung',
  customer_billing_report_last_reading_date_table_header: 'Datum der letzten Ablesung',
  customer_billing_report_device_number_table_header: 'Gerätenummer',
  customer_billing_report_last_config_date_table_header: 'Datum der letzten Konfiguration',
  customer_billing_report_billing_group_table_header: 'Fakturierungsgruppe',
  customer_billing_report_meter_serial_table_header: 'Seriennummer',
  customer_billing_report_diameter_table_header: 'Durchmesser',
  customer_billing_report_meter_brand_table_header: 'Marke',
  customer_billing_report_meter_model_table_header: 'Modell',
  customer_billing_report_default_error:
    'Bei der Erstellung des Berichts ist ein Fehler aufgetreten',
  customer_billing_report_contract_number_table_header: 'Vertragsnummer',
  customer_billing_report_device_name_table_header: 'Gerätename',
  customer_billing_report_sensor_name_table_header: 'Sensorenname',

  //license
  license_license_warning: 'Lizenzwarnung',
  license_license_warning_per_reading_over_limit_singular:
    'vom Typ pro Lesung überschreitet das Limit',
  license_license_warning_expire_singular: 'läuft bald ab',
  license_license_warning_per_reading_over_limit_plural:
    'vom Typ pro Lesungen überschreiten das Limit',
  license_license_warning_expire_plural: 'laufen bald ab',
  license_max_count_error: 'Maximale Anzahl darf nicht 0 sein',

  license_header: 'Lizenz',
  license_table_company_name: 'Firmenname',
  license_table_license_type: 'Lizenztyp',
  license_table_max_count: 'Maximale Anzahl',
  license_table_valid_from: 'Gültig von',
  license_table_valid_to: 'Gültig bis',
  license_table_first_reading_date: 'Datum der ersten Ablesung',
  license_table_last_reading_date: 'Datum der letzten Ablesung',
  license_table_active: 'Aktiv',
  license_table_valid: 'Gültig',
  license_table_prepaid: 'Vorausbezahlt',
  license_table_yes: 'Ja',
  license_table_no: 'Nein',
  license_table_actions: 'Aktionen',

  license_warning_access_hold: 'Kontozugriff ausgesetzt',
  license_warning_access_hold_description:
    'Ihr Zugriff auf die Plattform wurde vorübergehend aufgrund einer ungeklärten Zahlung ausgesetzt. Wir empfehlen Ihnen, sich an unseren Support zu wenden oder sich mit Ihrem zuständigen Vertreter in Verbindung zu setzen, um Ihnen bei der Lösung dieses Problems zu helfen.',
  license_warning_no_valid_license: 'Keine gültige Lizenz',
  license_warning_no_valid_license_description:
    'Wir konnten keine gültige Lizenz finden, die mit diesem Konto verknüpft ist. Bitte wenden Sie sich an Ihren zuständigen Vertreter oder kontaktieren Sie unseren Support um Hilfe.',
  license_warning_devices_count_limit_reached: 'Maximale Anzahl von Geräten erreicht',
  license_warning_devices_count_limit_reached_description:
    'Sie haben die maximale Anzahl von Geräten erreicht, die Sie gemäß der Lizenz mit dem Konto verknüpfen können. Wenn Sie mehr hinzufügen möchten, kontaktieren Sie bitte Ihren zuständigen Vertreter oder unseren Support für Unterstützung.',
  license_warning_generic_title: 'Keine Lizenz',
  license_warning_generic_description:
    'Kann aufgrund eines Lizenzproblems nicht fortgesetzt werden.',
  license_info_renew_button: 'Lizenz erneuern',
  license_info_deactivate_button: 'Lizenz deaktivieren',
  license_info_renew_modal_button: 'Erneuern',
  license_info_used_readings: 'Verwendete Berichte',
  license_info_readings_left: 'Verbleibende Berichte',
  license_renew_license_button: 'Erneuern',
  license_deactivate_license_button: 'Deaktivieren',
  license_select_company_warning_message: 'Wählen Sie ein Unternehmen aus, um fortzufahren',
  license_add_button: 'Lizenz hinzufügen',
  license_add_success_message: 'Lizenz wurde erfolgreich erstellt',
  license_add_error_message: 'Während des Vorgangs ist ein Fehler aufgetreten',
  license_max_devices: 'Max Geräte',
  license_max_readings: 'Max Berichte',
  license_max_sensors: 'Max Sensoren',
  license_company: 'Unternehmen',
  license_deactivate_warning: 'Dies wird den Zugriff der Benutzer auf die Plattform aussetzen',
  license_activate_warning: 'Dies wird den Benutzerzugang zur Plattform wiederherstellen',
  license_activate_license_button: 'Aktivieren',
  license_available_licenses: 'Verfügbare Lizenzen',
  license_add_license: 'Lizenz hinzufügen',
  license_status_active: 'Aktiv',
  license_status_inactive: 'Inaktiv',
  license_info_activate_button: 'Lizenz aktivieren',
  license_info_used_devices: 'Verwendete Geräte',
  license_info_devices_left: 'Verbleibende Geräte',
  license_error_page_access_restricted: 'Zugriff eingeschränkt',
  license_valid_license_existing: 'Sie haben bereits eine gültige Lizenz dieses Typs!',
  license_conflicting_license_date: 'Es gibt eine gültige Lizenz für denselben Zeitraum',

  license_date_range: 'Datumsbereich',
  license_validity_period: 'Gültigkeitszeitraum',
  provide_period: 'Bitte Zeitraum angeben',
  license_table_current_count: 'Aktuelle Anzahl',

  //Password
  change_password: 'Passwort ändern',
  current_password: 'Aktuelles Passwort',
  new_password: 'Neues Passwort',
  confirm_new_password: 'Neues Passwort bestätigen',
  customer_info_saved: 'Kundeninformationen gespeichert',

  password_min_length: 'Das Passwort muss mindestens 10 Zeichen lang sein',
  password_uppercase: 'Das Passwort muss mindestens einen Großbuchstaben enthalten',
  password_lowercase: 'Das Passwort muss mindestens einen Kleinbuchstaben enthalten',
  password_number: 'Das Passwort muss mindestens eine Zahl enthalten',
  password_special_char: 'Das Passwort muss mindestens ein Sonderzeichen enthalten',
  password_mismatch: 'Passwörter stimmen nicht überein',

  /*
   * |=========================|
   * |     Reset Password      |
   * |=========================|
   */
  reset_password_check_email_for_reset_link:
    'Überprüfen Sie Ihre E-Mail für den Link zum Zurücksetzen des Passworts',
  reset_password_default_error_message:
    'Beim Versuch, Ihr Passwort zurückzusetzen, ist ein Fehler aufgetreten',
  reset_password_change_password_label: 'Passwort ändern',
  reset_password_send_btn: 'Senden',

  /*
   * |==============================|
   * |  Sensors and Network Config  |
   * |==============================|
   */

  //headers
  sensors_and_network_config_network_config: 'Netzwerkkonfiguration des Geräts',
  sensors_and_network_config_device_details: 'Gerätedetails',
  sensors_and_network_config_add_sensor: 'Sensor hinzufügen',

  //messages
  sensors_and_network_save_success: 'Die Konfiguration wurde erfolgreich gespeichert.',
  sensors_and_network_save_error: 'Beim Speichern der Konfiguration ist ein Problem aufgetreten.',
  sensors_and_network_formula_validation_default_error: 'Die Formulaprüfung ist fehlgeschlagen.',
  sensors_and_network_config_required_field_error: 'Dieses Feld ist erforderlich',

  //labels
  sensors_and_network_config_sensor_index: 'Sensorindex',
  wildPoint_threshold: 'Schwellenwert für Ausreißer',
  scale: 'Skalierung',
  precision: 'Genauigkeit',
  initial_value: 'Anfangswert',

  //buttons
  sensors_and_network_config_reset_btn: 'Zurücksetzen',

  //tooltips
  config_tooltip_select_sensor_icon: 'Sensor-Symbol auswählen',
  config_tooltip_sensor_name: 'Sensorname',
  config_tooltip_enable_disable_sensor: 'Sensor aktivieren/deaktivieren',
  config_tooltip_reset_sensor: 'Neue Änderungen für diesen Sensor zurücksetzen',
  config_tooltip_reset_all_fields: 'Alle Felder auf die zuletzt gespeicherten Werte zurücksetzen',
  config_tooltip_delete_sensor: 'Sensor löschen',
  config_tooltip_sensor_description: 'Sensorbeschreibung',
  config_tooltip_sensor_model: 'Sensormodell',
  config_tooltip_sensor_serial_number: 'Seriennummer des Sensors',
  config_tooltip_sensor_manufacturer: 'Hersteller des Sensors',
  config_tooltip_sensor_useInSensorsAggregation:
    'Gibt an, ob die Daten vom automatischen Datenaggregator von Thingslog verwendet werden sollen.',
  config_tooltip_sensor_visibility:
    'Legt fest, ob der Sensor im Thingslog-Lösungsportal sichtbar sein soll.',
  config_tooltip_sensor_scale:
    'Die Genauigkeit nach dem Dezimalpunkt für alle Berechnungen mit der Formel.',
  config_tooltip_port_formula: 'Wird zur Umrechnung von Roh-ADC-Werten in mA oder V verwendet',
  config_tooltip_sensor_formula:
    'Wird zur Umrechnung von X in mA oder V in den gemessenen Wert verwendet, z. B. Füllstand, Druck, Temperatur und andere.',
  config_tooltip_sensor_pulseRate: 'Wie viel einer Einheit entspricht einem Impuls',
  config_tooltip_sensor_offset:
    'Eine numerische Zahl (+ oder -), die zu den vom Gerät gesendeten Messwerten addiert wird.',
  config_tooltip_sensor_flow_units: 'Einheiten der Durchflussrate - z. B. m3/h oder kW/h',
  config_tooltip_sensor_flow_time_units:
    'Der für die Einheitsberechnung verwendete Zeitraum - z. B. Sekunden',
  config_tooltip_sensor_flow_conversion_coefficient:
    'Wie viele Zeiteinheiten erforderlich sind, um die Einheit aus den Rohdaten zu erreichen',

  config_tooltip_sensor_diameter: 'Rohrdurchmesser',
  config_tooltip_sensor_q3: 'Q3-Koeffizient des Wasserzählers',
  config_tooltip_sensor_r: 'Genauigkeit des Wasserzählers',
  config_tooltip_wildPoint_threshold:
    'Gibt die maximal zulässige Änderung zwischen aufeinanderfolgenden Sensorwerten an. Wird dieser Wert überschritten, wird das Paket als fehlerhaft markiert und verworfen.',

  /*
   * |==============================|
   * |     Documentation Page       |
   * |==============================|
   */

  documentation_title: 'Dokumentation',
  documentation_platform: 'Plattform-Dokumentation',
  documentation_data_logger: 'Datenlogger-Dokumentation',
  documentation_communication_protocol: 'Kommunikationsprotokoll-Dokumentation',
  documentation_sign_in_main_menu: 'Anmeldung/Registrierung und Hauptmenü',
  documentation_account_management: 'Verwaltung von ThingsLog-Konten',
  documentation_user_management: 'Verwaltung von ThingsLog-Benutzern',
  documentation_data_loggers_configuration: 'Konfiguration von ThingsLog-Datenloggern',
  documentation_alarms_value_range_events:
    'Konfiguration und Überprüfung von ThingsLog-Alarmen und Wertebereichsereignissen',
  documentation_modbus_slave_devices:
    'Port- & Sensor-Parameterkonfiguration für Modbus-Slave-Geräte',
  documentation_tasmota_devices: 'Einrichtung von Tasmota-Geräten zur Nutzung mit ThingsLog',
  documentation_modbus_setup: 'Einrichtung von Modbus-Slave-Geräten für ThingsLog-Controller',
  documentation_licenses: 'Lizenzen',
  documentation_old_user_manual: 'Altes Benutzerhandbuch',
  documentation_data_logger_manual: 'Benutzerhandbuch für Thingslog-Datenlogger',
  documentation_data_logger_command_guide: 'Befehlsleitfaden für Thingslog-Datenlogger',
  documentation_lora_protocol: 'Offenes LoRa-Datenprotokoll',
  documentation_mqtt_protocol: 'MQTT-Offenes Datenprotokoll',
  documentation_getting_started_training_guide: 'Schulungsleitfaden „Erste Schritte“',
  documentation_view_pdf: 'PDF anzeigen',

  /*
   * |=====================|
   * | Device Nodes Page  |
   * |=====================|
   */

  device_nodes_table_no_links_found: 'Keine Geräteknotenverbindungen gefunden',
  device_nodes_table_error: 'Fehler beim Abrufen der Geräteknotenverbindungen',
  device_nodes_table_source_device_number: 'Quellgerätenummer',
  device_nodes_table_source_sensor_index: 'Quellsensorindex',
  device_nodes_table_target_device_number: 'Zielgerätenummer',
  device_nodes_table_target_sensor_index: 'Zielsensorindex',
  device_nodes_table_is_active: 'Ist aktiv',

  device_nodes_create_link: 'Verbindung erstellen',
  device_nodes_source_device_required: 'Quellgerät ist erforderlich',
  device_nodes_source_device: 'Quellgerät',
  device_nodes_sensor_index_required: 'Sensorindex ist erforderlich',
  device_nodes_sensor_index_min: 'Sensorindex muss mindestens 0 sein',
  device_nodes_source_sensor_index: 'Quellsensorindex',
  device_nodes_target_device_required: 'Zielgerät ist erforderlich',
  device_nodes_target_device: 'Zielgerät',
  device_nodes_target_sensor_index: 'Zielsensorindex',
  device_nodes_is_active: 'Ist aktiv',
  device_nodes_create_link_button: 'Verbindung erstellen',
  device_nodes_same_device_error: 'Quellgerät und Zielgerät können nicht identisch sein',

  device_nodes_delete_links: 'Links löschen',
  device_nodes_device_required: 'Gerät ist erforderlich',
  device_nodes_device: 'Gerät',
  device_nodes_role_required: 'Rolle ist erforderlich',
  device_nodes_role: 'Rolle',
  device_nodes_role_source: 'Quelle',
  device_nodes_role_target: 'Ziel',
  device_nodes_sensor_index: 'Sensor (Optional)',
  device_nodes_no_sensors_available: 'Keine Sensoren verfügbar',
  device_nodes_sensor_optional: 'Leer lassen, um alle Gerätelinks zu löschen',
  device_nodes_delete_warning: 'Warnung: Diese Aktion kann nicht rückgängig gemacht werden!',
  device_nodes_delete_button: 'Links löschen',

  /*
   * |======================|
   * | Scheduled Reports   |
   * |======================|
   */
  // Generated Reports Page
  generated_reports_header: 'Generierte Berichte',
  generated_reports_select_company_message:
    'Bitte wählen Sie ein Unternehmen aus, um generierte Berichte anzuzeigen',
  generated_reports_default_error:
    'Beim Abrufen der generierten Berichte ist ein Fehler aufgetreten',
  generated_reports_config_button: 'Konfiguration',
  generated_reports_config_name_header: 'Berichtskonfigurationsname',
  generated_reports_date_header: 'Berichtsdatum',
  generated_reports_type_header: 'Berichtstyp',
  generated_reports_file_name_header: 'Dateiname',
  generated_reports_parameters_header: 'Parameter',

  // Report Configs Page
  report_configs_header: 'Berichtskonfigurationen',
  report_configs_select_company_message:
    'Bitte wählen Sie ein Unternehmen aus, um Berichtskonfigurationen zu verwalten',
  report_configs_default_error:
    'Beim Abrufen der Berichtskonfigurationen ist ein Fehler aufgetreten',
  report_configs_name_header: 'Berichtsname',
  report_configs_type_header: 'Berichtstyp',
  report_configs_occurrence_header: 'Häufigkeit',
  report_configs_device_groups_header: 'Gerätegruppen',
  report_configs_email_list_header: 'E-Mail-Liste',
  report_configs_start_date_header: 'Startdatum',
  report_configs_end_date_header: 'Enddatum',
  report_configs_next_execution_header: 'Nächste Ausführung',
  report_configs_actions_header: 'Aktionen',
  report_configs_delete_action: 'Löschen',
  report_configs_delete_success: 'Berichtskonfiguration erfolgreich gelöscht',
  report_configs_delete_error: 'Beim Löschen der Berichtskonfiguration ist ein Fehler aufgetreten',
  report_configs_create_button: 'Berichtskonfiguration erstellen',
  report_configs_edit_action: 'Bearbeiten',

  // Report Config Form
  report_config_form_report_name: 'Berichtsname',
  report_config_form_report_type: 'Berichtstyp',
  report_config_form_occurrence: 'Häufigkeit',
  report_config_form_device_groups: 'Gerätegruppen',
  report_config_form_email_list: 'E-Mail-Liste',
  report_config_form_email_list_hint: 'Mehrere E-Mails mit Kommas trennen',
  report_config_form_start_date: 'Startdatum',
  report_config_form_end_date: 'Enddatum',
  report_config_form_calculate: 'Berechnen',
  report_config_form_calc_min: 'Minimum',
  report_config_form_calc_max: 'Maximum',
  report_config_form_calc_average: 'Durchschnitt',
  report_config_form_cancel: 'Abbrechen',
  report_config_form_create: 'Erstellen',
  report_config_form_update: 'Aktualisieren',
  report_config_form_field_required: 'Dieses Feld ist erforderlich',
  report_config_form_device_groups_required: 'Mindestens eine Gerätegruppe muss ausgewählt werden',
  report_config_form_license_settings: 'Lizenzberichtseinstellungen',
  report_config_form_license_is_active: 'Ist aktiv',
  report_config_form_license_is_valid: 'Ist gültig',

  // Report Types
  report_type_consumption: 'Verbrauchsbericht',
  report_type_consumption_export: 'Verbrauchsexport',
  report_type_customer_billing: 'Kundenabrechnungsbericht',
  report_type_alarm: 'Alarmbericht',
  report_type_transmission: 'Übertragungsbericht',
  report_type_license: 'Lizenzbericht',

  // Report Occurrence
  report_occurrence_daily: 'Täglich',
  report_occurrence_weekly: 'Wöchentlich',
  report_occurrence_monthly: 'Monatlich',

  // Create/Edit Pages
  report_config_create_header: 'Berichtskonfiguration erstellen',
  report_config_create_success: 'Berichtskonfiguration erfolgreich erstellt',
  report_config_create_error: 'Beim Erstellen der Berichtskonfiguration ist ein Fehler aufgetreten',
  report_config_edit_header: 'Berichtskonfiguration bearbeiten',
  report_config_update_success: 'Berichtskonfiguration erfolgreich aktualisiert',
  report_config_update_error:
    'Beim Aktualisieren der Berichtskonfiguration ist ein Fehler aufgetreten',
  report_config_fetch_error: 'Beim Abrufen der Berichtskonfiguration ist ein Fehler aufgetreten',
  report_config_not_found: 'Berichtskonfiguration nicht gefunden',
  report_config_form_email_list_required: 'Mindestens eine E-Mail-Adresse ist erforderlich',
  report_config_form_email_invalid: 'Ungültige E-Mail-Adresse: {{email}}',
  report_config_form_email_no_spaces: 'E-Mail-Adressen dürfen keine Leerzeichen enthalten',
  report_configs_delete_confirm_title: 'Berichtskonfiguration löschen',
  report_configs_delete_confirm_message:
    'Sind Sie sicher, dass Sie die Berichtskonfiguration "{{reportName}}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  report_configs_delete_cancel: 'Abbrechen',
  report_configs_delete_confirm: 'Löschen',
  report_configs_deleting: 'Löschen...',

  /*
   * |====================|
   * | Sensors Data Page  |
   * |====================|
   */

  // Page
  sensors_data_no_selection_made: 'Keine Auswahl getroffen',
  sensors_data_no_selection_subtitle:
    'Verwenden Sie die Steuerelemente oben, um ein Gerät oder eine Gruppe von Geräten auszuwählen, um deren Sensormesswerte anzuzeigen.',

  // Device Readings Selector Generic
  sensors_data_select_device_group: 'Gerätegruppe auswählen',
  sensors_data_search_device_group: 'Suche nach Gerätegruppennamen',
  sensors_data_add: 'Hinzufügen',
  sensors_data_select_device: 'Gerät auswählen',
  sensors_data_search_device: 'Suche nach Gerätename oder -nummer',
  sensors_data_select_sensor: 'Sensor auswählen',
  sensors_data_search_sensor: 'Suche nach Sensorname oder -index',
  sensors_data_select_devices: 'Geräte auswählen',
  sensors_data_select_sensor_type: 'Sensortyp auswählen',
  sensors_data_search_sensor_type: 'Suche nach Sensortyp',
  sensors_data_submit: 'Absenden',

  // Device Readings Selector Specific
  sensors_data_select_sensors: 'Sensoren auswählen',

  // Selected Items Display
  sensors_data_group: 'Gruppe',

  // Readings Data Display
  sensors_data_click_to_view_readings: 'Klicken Sie, um Messwerte anzuzeigen',
  sensors_data_view_sensor_data_subtitle: 'Sensordaten und Exportinformationen anzeigen',
  sensors_data_raw: 'Roh',
  sensors_data_export: 'Exportieren',
  sensors_data_format: 'Format',
  sensors_data_csv: 'CSV',
  sensors_data_excel: 'EXCEL',
  sensors_data_device_number: 'Gerätenummer',
  sensors_data_device_name: 'Gerätename',
  sensors_data_sensor_name: 'Sensorname',
  sensors_data_date: 'Datum',
  sensors_data_value: 'Wert',
  sensors_data_no_data_available: 'Keine Daten verfügbar',
  sensors_data_sensor_index: 'Sensorindex',
  sensors_data_counters: 'Zähler',
  sensors_data_previous: 'Vorherig',
  sensors_data_delta: 'Delta',
  sensors_data_collapse: 'Einklappen',

  // Sensors Data Chart
  sensors_data_chart_no_data_available: 'Keine Daten verfügbar',
  sensors_data_chart_no_numeric_data_subtitle:
    'Die Anfrage war erfolgreich, aber es wurden keine numerischen Daten für den ausgewählten Bereich zurückgegeben.',
  sensors_data_chart_min: 'Min -',
  sensors_data_chart_max: 'Max -',

  // Sensors Data Map
  sensors_data_map_loading: 'Karte wird geladen...',

  //Warranty Data
  manufacturing_date: 'Herstellungsdatum',
  warranty_type: 'Garantietyp',
  warranty_extended_support: 'Erweiterter Support',
  warranty_basic: 'Basis',
  warranty_status: 'Garantiestatus',
  warranty_status_UNKNOWN: 'Unbekannt',
  warranty_status_IN_WARRANTY: 'In Garantie',
  warranty_status_EXPIRED: 'Abgelaufen',
  warranty_period_months: 'Garantiezeitraum',
  install_date: 'Installationsdatum',
  install_warranty_exp_date: 'Ablaufdatum der Installationsgarantie',
  install_warranty_period_months: 'Garantiezeitraum der Installation',

  // Mobile Query Preview
  sensors_data_mobile_groups: 'Gruppe(n)',
  sensors_data_mobile_sensors: 'Sensor(en)',
  sensors_data_mobile_types: 'Typ(en)',
  sensors_data_mobile_no_filters_selected: 'Keine Filter ausgewählt',

  // Quick Sensor Selector
  sensors_data_quick_select_sensor: 'Wählen Sie einen Sensor aus, um Messwerte anzuzeigen',

  // Mobile Fab Button
  sensors_data_view_table: 'Tabelle anzeigen',
  sensors_data_view_chart: 'Diagramm anzeigen',
  // Fallbacks added to keep locale keys aligned with English.
  confirm_registration_welcome_to_thingslog: 'Welcome to Thingslog!',
  confirm_registration_completed: 'REGISTRATION COMPLETED',
  confirm_registration_failed: 'REGISTRATION FAILED',
  confirm_registration_completed_description:
    'Your registration process is completed. You can login now. If you face issue, contact our support at {{email}}',
  confirm_registration_failed_description:
    'We encountered a problem with registration. If you face issues logging in, please, contact our support at {{email}}',
  confirm_registration_visit_website: 'Visit Our Website',
  confirm_registration_visit_ecommerce: 'Visit Our Online Store',
  device_counter_statistics_must_have_initialized_params:
    'Parameters Q3, R, and Diameter are required on pulse input connected to a water meter sensor.',
  transmissions_page_yes: 'Yes',
  transmissions_page_no: 'No',
  device_groups_add_sensor_device: 'Add sensor and device to group',
  value_range_name_incorrect_time: 'Incorrect time format',
  value_range_error_occurred: 'An error occurred',
  // Dashboard localization additions
  cancel: 'Abbrechen',
  edit: 'Bearbeiten',
  save_btn: 'Speichern',
  resize: 'Größe ändern',
  value: 'Wert',
  time: 'Zeit',
  dashboards_title: 'Dashboards',
  dashboard_add_dashboard: 'Hinzufügen Dashboard',
  dashboard_edit_dashboard: 'Bearbeiten Dashboard',
  dashboard_delete_dashboard: 'Löschen Dashboard',
  dashboard_search_dashboards: 'Suchen Dashboards',
  dashboard_search_by_name: 'Suche nach Name',
  dashboard_create_dashboard: 'Erstellen Dashboard',
  dashboard_save_dashboard: 'Speichern Dashboard',
  dashboard_name: 'Dashboard Name',
  dashboard_name_required: 'Dashboard Name ist erforderlich',
  dashboard_name_max_length: 'Dashboard Name muss weniger als 100 Zeichen haben',
  dashboard_time_period: 'Zeitraum',
  dashboard_dashboard_time_period: 'Dashboard-Zeitraum',
  dashboard_dashboard_time_period_description:
    'Der Standardzeitraum für die Daten dieses Dashboards.',
  dashboard_save_period: 'Speichern Zeitraum',
  dashboard_edit_dashboard_period: 'Bearbeiten Dashboard-Zeitraum',
  dashboard_period: 'Dashboard-Zeitraum',
  dashboard_predefined_period: 'Vordefinierter Zeitraum',
  dashboard_period_dashboard: 'Dashboard',
  dashboard_period_predefined: 'Vordefiniert',
  dashboard_period_preset: 'Voreinstellung',
  dashboard_period_custom: 'Benutzerdefiniert',
  dashboard_timespan_today: 'Heute',
  dashboard_timespan_yesterday: 'Gestern',
  dashboard_timespan_this_week: 'Diese Woche',
  dashboard_timespan_this_month: 'Dieser Monat',
  dashboard_timespan_this_year: 'Dieses Jahr',
  dashboard_timespan_past_1d: 'Letzter 1 Tag',
  dashboard_timespan_past_1w: 'Letzte 1 Woche',
  dashboard_timespan_past_1m: 'Letzter 1 Monat',
  dashboard_timespan_past_1y: 'Letztes 1 Jahr',
  dashboard_start_date_required: 'Start Datum erforderlich',
  dashboard_end_date_required: 'Enddatum ist erforderlich',
  dashboard_end_date_before_start_error: 'Ende Datum vor Start Fehler',
  dashboard_predefined_period_required: 'vordefiniert Zeitraum erforderlich',
  dashboard_default_dashboard_name: 'Standard Dashboard',
  dashboard_loading: 'Wird geladen...',
  dashboard_redirecting: 'Weiterleitung...',
  dashboards_load_error: 'Laden Fehler',
  dashboard_load_error: 'Laden Fehler',
  dashboard_loading_data_sources: 'Laden Daten Quellen',
  dashboard_data_sources_load_error: 'Daten Quellen Laden Fehler',
  dashboard_empty_title: 'Erstellen Sie Ihr erstes Widget',
  dashboard_empty_description:
    'Fügen Sie ein Widget hinzu, um Daten in diesem Dashboard anzuzeigen.',
  dashboard_confirm_changes_title: 'Änderungen bestätigen',
  dashboard_save_layout_confirmation:
    'Möchten Sie Ihre Änderungen wirklich speichern? Alle Änderungen werden auf das Dashboard angewendet.',
  dashboard_save_layout: 'Speichern Layout',
  dashboard_edit_layout: 'Bearbeiten Layout',
  dashboard_add_widget: 'Widget hinzufügen',
  dashboard_widgets: 'Widgets',
  dashboard_widget: 'Widget',
  dashboard_untitled_widget: 'Unbenanntes Widget',
  dashboard_no_widgets_yet: 'nein Widgets yet',
  dashboard_create_widget: 'Widget erstellen',
  dashboard_save_widget: 'Widget speichern',
  dashboard_edit_widget: 'Widget bearbeiten',
  dashboard_delete_widget: 'Widget löschen',
  dashboard_yes_delete: 'Ja, löschen',
  dashboard_widget_no_longer_exists: 'Widget existiert nicht mehr.',
  dashboard_widget_delete_confirmation_prefix: 'Dadurch wird das Widget dauerhaft gelöscht',
  dashboard_widget_delete_confirmation_suffix: 'Diese Aktion kann nicht rückgängig gemacht werden.',
  dashboards_empty_no_dashboards_title: 'Keine Dashboards',
  dashboards_empty_no_results_title: 'Keine Ergebnisse',
  dashboards_empty_no_dashboards_description: 'Es wurden noch keine Dashboards erstellt.',
  dashboards_empty_no_results_description: 'Keine Dashboards entsprechen Ihrer Suche.',
  dashboard_add_default_dashboard: 'Hinzufügen Standard Dashboard',
  dashboard_this_dashboard: 'dies Dashboard',
  dashboard_delete_confirmation: 'Möchten Sie {{name}} wirklich löschen?',
  dashboard_no_longer_exists: 'Dashboard Widget existiert nicht mehr.',
  dashboard_edit_named_dashboard: 'Bearbeiten {{name}}',
  dashboard_fallback_dashboard: 'Dashboard',
  dashboard_edit_current_dashboard: 'Bearbeiten aktuell Dashboard',
  dashboard_all_dashboards: 'all Dashboards',
  dashboard_start_selector_guide: 'Start Auswahl Anleitung',
  dashboard_close_dashboards: 'Schließen Dashboards',
  dashboard_open_dashboards: 'Öffnen Dashboards',
  dashboard_edit_period: 'Bearbeiten Dashboard Zeitraum',
  dashboard_variables: 'Variablen',
  dashboard_hide_app_header: 'App-Kopfzeile ausblenden',
  dashboard_show_app_header: 'App-Kopfzeile anzeigen',
  dashboard_start_tour: 'Start Tour',
  dashboard_remove_from_favorites: 'Aus Favoriten entfernen',
  dashboard_add_to_favorites: 'Zu Favoriten hinzufügen',
  dashboard_default_dashboard: 'Standard Dashboard',
  dashboard_set_as_default: 'Als Standard festlegen',
  dashboard_favorite_tooltip: 'Als Favorit markieren',
  dashboard_default_tooltip: 'Standard-Dashboard',
  dashboard_widget_type: 'Widget-Typ',
  dashboard_widget_type_required: 'Widget-Typ ist erforderlich',
  dashboard_widget_type_line_chart: 'Liniendiagramm',
  dashboard_widget_type_bar_chart: 'Balkendiagramm',
  dashboard_widget_type_pie_chart: 'Kreisdiagramm',
  dashboard_widget_type_area_chart: 'Flächendiagramm',
  dashboard_widget_type_gauge: 'Anzeige',
  dashboard_widget_type_value: 'Wert',
  dashboard_widget_type_table: 'Tabelle',
  dashboard_widget_title: 'Titel',
  dashboard_widget_title_required: 'Titel ist erforderlich',
  dashboard_widget_title_max_length: 'Der Titel muss weniger als 100 Zeichen haben',
  dashboard_data_source: 'Datenquelle',
  dashboard_data_source_required: 'Datenquelle ist erforderlich',
  dashboard_query_settings: 'Abfrageeinstellungen',
  dashboard_no_data_sources_available: 'Keine Datenquellen verfügbar',
  dashboard_no_data_sources_description:
    'Konfigurieren Sie eine Dashboard-Datenquelle, bevor Sie Widgets erstellen oder bearbeiten.',
  dashboard_select_data_source_to_configure_query:
    'Wählen Sie eine Datenquelle, um die Abfrage zu konfigurieren.',
  dashboard_query_type_not_supported: 'Dieser Abfragetyp wird noch nicht unterstützt.',
  dashboard_no_widget_timeframe: 'Kein Widget-Zeitraum',
  dashboard_no_widget_timeframe_description: 'Dieses Widget übernimmt den Zeitraum vom Dashboard.',
  dashboard_widget_time_period: 'Widget-Zeitraum',
  dashboard_widget_time_period_description:
    'Legen Sie einen eigenen Zeitraum für dieses Widget fest oder verwenden Sie den Dashboard-Zeitraum.',
  dashboard_edit_widget_timeframe: 'Widget-Zeitraum bearbeiten',
  dashboard_edit_widget_timeframe_inherited:
    'Widget-Zeitraum bearbeiten. Wird derzeit vom Dashboard übernommen.',
  dashboard_widget_settings: 'Widget-Einstellungen',
  dashboard_shift_scroll_to_zoom: 'Shift + Scrollen zum Zoomen',
  dashboard_zoom_in: 'Vergrößern',
  dashboard_zoom_out: 'Verkleinern',
  dashboard_zoom_reset: 'Zoom zurücksetzen',
  dashboard_inherited_timeframe_label: 'Dashboard: {{label}}',
  dashboard_edit_timeframe: 'Zeitraum bearbeiten',
  dashboard_edit_widget_period: 'Widget-Zeitraum bearbeiten',
  dashboard_edit_named_widget: 'Bearbeiten {{name}}',
  dashboard_edit_named_widget_period: 'Bearbeiten {{name}} Zeitraum',
  dashboard_data_type: 'Datentyp',
  dashboard_data_type_description:
    'Wählen Sie, ob Messwerte oder berechnete Durchflusswerte bevorzugt werden.',
  dashboard_readings: 'Messwerte',
  dashboard_query_time_period_description: 'Wählen Sie den Zeitraum für die Abfragedaten aus.',
  dashboard_battery_level: 'Batteriestand',
  dashboard_battery_level_description: 'Begrenzt das Widget auf einen Batteriebereich in Prozent.',
  dashboard_signal_level: 'Signalstärke',
  dashboard_signal_level_description: 'Begrenzt das Widget auf einen Signalbereich in Prozent.',
  dashboard_signal_values: 'Signalwerte',
  dashboard_signal_values_description: 'Wählen Sie, welche Signalwerte angezeigt werden.',
  dashboard_signal_value_required: 'Wählen Sie mindestens einen Signalwert aus',
  dashboard_transmission_values: 'Übertragungswerte',
  dashboard_transmission_values_description:
    'Wählen Sie, welche Übertragungswerte angezeigt werden.',
  dashboard_transmission_value_required: 'Wählen Sie mindestens einen Übertragungswert aus',
  dashboard_days: 'Tage',
  dashboard_transmissions: 'Übertragungen',
  dashboard_count: 'Anzahl',
  dashboard_unit_days: 'Tage',
  dashboard_transmitting: 'Überträgt',
  devices: 'Geräte',
  dashboard_device_sensor: 'GeräteSensor',
  dashboard_device_sensor_description: 'Wählen Sie Gerät und Sensor für dieses Widget aus.',
  dashboard_device_required: 'Gerät ist erforderlich',
  dashboard_sensor_required: 'Sensor ist erforderlich',
  dashboard_devices_optional_description:
    'Pick Geräte to include. Leave empty to include all Geräte.',
  dashboard_no_devices_selected_uses_all:
    'Keine Geräte ausgewählt. Das Widget verwendet alle Geräte.',
  dashboard_device_groups: 'Gerätegruppen',
  dashboard_device_groups_description:
    'Wählen Sie eine oder mehrere Gerätegruppen für die Abfrage aus.',
  dashboard_select_one_device_group_required: 'Wählen Sie mindestens eine Gerätegruppe aus',
  dashboard_device_groups_optional_description:
    'Optionale Gruppenquellen für die gemischte Abfrage.',
  dashboard_no_groups_selected: 'Keine Gruppen ausgewählt.',
  dashboard_device_sensors: 'GeräteSensoren',
  dashboard_device_sensors_description:
    'Fügen Sie Geräte- und Sensorpaare hinzu, die gelesen werden sollen.',
  dashboard_device_sensors_optional_description:
    'Optionale Paare aus Gerätenummern und Sensorindizes.',
  dashboard_add_device_sensor_required: 'Fügen Sie mindestens einen Gerätesensor hinzu',
  dashboard_add_device_sensor: 'Hinzufügen GeräteSensor',
  dashboard_remove_device_sensor: 'Remove Gerät Sensor',
  dashboard_device_sensor_types: 'GeräteSensortypen',
  dashboard_device_sensor_types_description:
    'Wählen Sie Geräte und den Sensortyp, der von ihnen gelesen werden soll.',
  dashboard_device_sensor_types_optional_description:
    'Optionale Gerätegruppen, die nach Sensortyp abgeglichen werden.',
  dashboard_add_device_sensor_type_required: 'Fügen Sie mindestens einen Gerätesensortyp hinzu',
  dashboard_sensor_type: 'Sensor Typ',
  dashboard_add_sensor_type: 'Hinzufügen Sensor Typ',
  dashboard_remove_sensor_type: 'Sensortyp entfernen',
  dashboard_variable: 'Variable',
  dashboard_sensor_index_option: 'Sensor {{index}}',
  dashboard_visualization: 'Visualisierung',
  dashboard_visualization_description: 'Anzeigeoptionen und Diagrammstil',
  dashboard_visualization_show_grid: 'Raster anzeigen',
  dashboard_visualization_show_legend: 'Legende anzeigen',
  dashboard_visualization_render_legend_aside: 'Legende an der Seite',
  dashboard_visualization_show_legend_aside: 'Legende an der Seite',
  dashboard_visualization_show_x_axis_labels: 'X-Achsenbeschriftungen anzeigen',
  dashboard_visualization_show_y_axis_labels: 'Y-Achsenbeschriftungen anzeigen',
  dashboard_visualization_line_thickness: 'Linienstärke',
  dashboard_visualization_interpolation: 'Interpolation',
  dashboard_visualization_show_points: 'Punkte anzeigen',
  dashboard_visualization_points_hidden_helper:
    'Punkte werden automatisch ausgeblendet, wenn die Zeitreihe mehr als {{count}} Datenpunkte hat.',
  dashboard_visualization_stack_series: 'Reihen stapeln',
  dashboard_visualization_fill_opacity: 'Fülltransparenz',
  dashboard_visualization_orientation: 'Ausrichtung',
  dashboard_visualization_grouping: 'Gruppierung',
  dashboard_visualization_bar_thickness: 'Balkenstärke',
  dashboard_visualization_shape: 'Form',
  dashboard_visualization_gauge_type: 'Anzeigetyp',
  dashboard_visualization_bar_orientation: 'Balkenausrichtung',
  dashboard_visualization_minimum: 'Minimum',
  dashboard_visualization_maximum: 'Maximum',
  dashboard_visualization_gauge_color: 'Anzeigefarbe',
  dashboard_visualization_value_color: 'Grundfarbe',
  dashboard_visualization_value_prefix: 'Präfix',
  dashboard_visualization_value_suffix: 'Suffix',
  dashboard_visualization_value_stacked: 'Präfix oben, Suffix unten',
  dashboard_visualization_value_compact: 'Kompakte Zahlen',
  dashboard_visualization_value_target: 'Zielwert',
  dashboard_visualization_value_show_target_percentage: '% vom Ziel anzeigen',
  dashboard_visualization_value_text_color: 'Benutzerdefinierte Textfarbe',
  dashboard_visualization_colors: 'Farben',
  dashboard_value_percent_of_target: '{{percent}}% vom Ziel',
  dashboard_value_percent_above_target: '{{percent}}% über dem Ziel',
  dashboard_visualization_show_value: 'Wert anzeigen',
  dashboard_visualization_show_min_max: 'Min../Max.. anzeigen',
  dashboard_visualization_show_thresholds: 'Schwellen anzeigen',
  dashboard_visualization_paginate_rows: 'Zeilen paginieren',
  dashboard_visualization_thresholds: 'Schwellen',
  dashboard_visualization_add_threshold: 'Schwelle hinzufügen',
  dashboard_visualization_level: 'Stufe',
  dashboard_visualization_label: 'Bezeichnung',
  dashboard_visualization_color: 'Farbe',
  dashboard_visualization_remove_threshold: 'Schwelle entfernen',
  dashboard_visualization_threshold_warning: 'Warnung',
  dashboard_visualization_threshold_critical: 'Kritisch',
  dashboard_visualization_threshold_named: 'Schwelle {{index}}',
  dashboard_visualization_option_fine: 'Fein',
  dashboard_visualization_option_standard: 'Standard',
  dashboard_visualization_option_bold: 'Stark',
  dashboard_visualization_option_straight: 'Gerade',
  dashboard_visualization_option_smooth: 'Glatt',
  dashboard_visualization_option_stepped: 'Stufig',
  dashboard_visualization_option_subtle: 'Dezent',
  dashboard_visualization_option_balanced: 'Ausgewogen',
  dashboard_visualization_option_solid: 'Durchgezogen',
  dashboard_visualization_option_vertical: 'Vertikal',
  dashboard_visualization_option_horizontal: 'Horizontal',
  dashboard_visualization_option_grouped: 'Gruppiert',
  dashboard_visualization_option_stacked: 'Gestapelt',
  dashboard_visualization_option_slim: 'Schmal',
  dashboard_visualization_option_regular: 'Normal',
  dashboard_visualization_option_wide: 'Breit',
  dashboard_visualization_option_pie: 'Kreis',
  dashboard_visualization_option_donut: 'visualization option donut',
  dashboard_visualization_option_dial: 'Skala',
  dashboard_visualization_option_bar: 'Balken',
  dashboard_add_variable: 'Hinzufügen Variable',
  dashboard_edit_variable: 'Bearbeiten Variable',
  dashboard_delete_variable: 'Löschen Variable',
  dashboard_variable_no_longer_exists: 'Variable existiert nicht mehr.',
  dashboard_edit_named_variable: 'Bearbeiten {{name}}',
  dashboard_variable_edit_mode_description:
    'Lokale Änderungen betreffen nur diese Dashboard-Ansicht. Remote-Änderungen aktualisieren die gespeicherte Variable.',
  dashboard_local: 'Lokal',
  dashboard_remote: 'remote',
  dashboard_variable_name: 'Variable Name',
  dashboard_variable_name_required: 'Variable Name ist erforderlich',
  dashboard_variable_name_pattern: 'Variable Name pattern',
  dashboard_variable_label: 'Bezeichnung',
  dashboard_variable_label_required: 'Bezeichnung is required',
  dashboard_variable_single: 'Einzeln',
  dashboard_variable_multi: 'Mehrfach',
  dashboard_variable_value: 'Wert',
  dashboard_variable_values: 'Werte',
  dashboard_variable_value_required: 'Wert is required',
  dashboard_variable_at_least_one_value_required: 'Mindestens ein Wert ist erforderlich',
  dashboard_variable_values_helper: 'Mehrere Werte mit Kommas trennen.',
  dashboard_apply_locally: 'Anwenden locally',
  dashboard_no_variables_yet: 'Keine Variablen',
  dashboard_no_variables_description: 'Für dieses Dashboard sind noch keine Variablen vorhanden.',
  dashboard_variable_value_count: '{{count}} Wert',
  dashboard_empty_value: 'Leer',
  dashboard_open_variable_actions: 'Öffnen {{name}} actions',
  dashboard_variable_delete_confirmation_prefix: 'Dadurch wird die Variable dauerhaft gelöscht',
  dashboard_no_data_available: 'Keine Daten verfügbar',
  dashboard_widget_failed_to_load_data: 'Daten konnten nicht geladen werden',
  dashboard_click_to_retry: 'Zum Wiederholen klicken',
  dashboard_chart_sampled_points_tooltip:
    'Eine Stichprobe echter Datenpunkte wird angezeigt. Zoomen Sie hinein, um ausgelassene Punkte zu sehen.',
  dashboard_chart_all_points_tooltip: 'Alle Datenpunkte der aktuellen Ansicht werden angezeigt.',
  dashboard_widget_no_areas: 'Dieses Widget hat keine Flächen zum Anzeigen.',
  dashboard_widget_no_bars: 'Dieses Widget hat keine Balken zum Anzeigen.',
  dashboard_widget_no_points: 'Dieses Widget hat keine Punkte zum Zeichnen.',
  dashboard_widget_no_slices: 'Dieses Widget hat keine Segmente zum Anzeigen.',
  dashboard_widget_too_many_slices: 'Zu viele Segmente zum Anzeigen',
  dashboard_widget_too_many_slices_description:
    'Dieses Widget hat {{slices}} Segmente. Wenn alle gezeichnet werden, lädt das Dashboard langsam und reagiert träge, und das Diagramm ist schwer lesbar.',
  dashboard_widget_render_anyway: 'Trotzdem anzeigen',
  dashboard_table_settings_missing: 'Tabelleneinstellungen fehlen.',
  dashboard_widget_no_rows: 'Dieses Widget hat keine Zeilen zum Anzeigen.',
  dashboard_gauge_settings_missing: 'Anzeigeeinstellungen fehlen.',
  dashboard_value_settings_missing: 'Werteinstellungen fehlen.',
  dashboard_widget_no_value: 'Dieses Widget hat keinen Wert zum Anzeigen.',
  dashboard_widget_no_numeric_value: 'Dieses Widget hat keinen numerischen Wert zum Anzeigen.',
  dashboard_timestamp: 'Zeitstempel',
  dashboard_alarm_type: 'Alarmtyp',
  dashboard_alarm_count: 'Alarmanzahl',
  dashboard_level: 'Stufe',
  dashboard_series_index: 'Reihe {{index}}',
  dashboard_gauge_normal: 'Normal',
  dashboard_gauge_threshold: 'Schwelle',
  dashboard_start_named_guide: 'Start named Anleitung',
  dashboard_expand_named: '{{title}} erweitern',
  dashboard_expand_named_widget: 'Widget {{title}} erweitern',
  dashboard_close_named: 'Schließen {{title}}',
  dashboard_close_named_widget: 'Schließen {{title}} Widget',
  dashboard_close_expanded_named_widget: 'Erweitertes Widget {{title}} schließen',
  dashboard_tour_header_dashboards: 'Hilfe: Kopfzeile Dashboards.',
  dashboard_tour_header_settings: 'Hilfe: Kopfzeile Einstellungen.',
  dashboard_tour_header_title: 'Hilfe: Kopfzeile Titel.',
  dashboard_tour_header_period: 'Hilfe: Kopfzeile Zeitraum.',
  dashboard_tour_header_layout: 'Hilfe: Kopfzeile Layout.',
  dashboard_tour_header_add_widget: 'Hilfe: Kopfzeile Hinzufügen Widget.',
  dashboard_tour_header_variables: 'Hilfe: Kopfzeile Variablen.',
  dashboard_tour_header_toggle_app_header: 'Hilfe: Kopfzeile Umschalten App Kopfzeile.',
  dashboard_tour_dashboard_canvas: 'Hilfe: Dashboard Arbeitsbereich.',
  dashboard_tour_selection_search: 'Hilfe: Auswahl Suche.',
  dashboard_tour_selection_add: 'Hilfe: Auswahl Hinzufügen.',
  dashboard_tour_selection_list: 'Hilfe: Auswahl Liste.',
  dashboard_tour_selection_favorite: 'Hilfe: Auswahl Favorit.',
  dashboard_tour_selection_default: 'Hilfe: Auswahl Standard.',
  dashboard_tour_selection_all: 'Hilfe: Auswahl alle.',
  dashboard_tour_widget_title: 'Hilfe: Widget Titel.',
  dashboard_tour_widget_type: 'Hilfe: Widget Typ.',
  dashboard_tour_widget_data_source: 'Hilfe: Widget Daten Quelle.',
  dashboard_tour_query_single_device: 'Hilfe: Abfrage einzeln Gerät.',
  dashboard_tour_query_single_sensor: 'Hilfe: Abfrage einzeln Sensor.',
  dashboard_tour_query_specific_devices: 'Hilfe: Abfrage bestimmte Geräte.',
  dashboard_tour_query_battery_range: 'Hilfe: Abfrage Batterie Bereich.',
  dashboard_tour_query_device_groups: 'Hilfe: Abfrage Gerät Gruppen.',
  dashboard_tour_query_device_sensor_list: 'Hilfe: Abfrage Gerät Sensor Liste.',
  dashboard_tour_query_device_sensor_device: 'Hilfe: Abfrage Gerät Sensor Gerät.',
  dashboard_tour_query_device_sensor_sensor: 'Hilfe: Abfrage Gerät Sensor Sensor.',
  dashboard_tour_query_device_sensor_add: 'Hilfe: Abfrage Gerät Sensor Hinzufügen.',
  dashboard_tour_query_device_type_list: 'Hilfe: Abfrage Gerät Typ Liste.',
  dashboard_tour_query_device_type_devices: 'Hilfe: Abfrage Gerät Typ Geräte.',
  dashboard_tour_query_device_type_sensor_type: 'Hilfe: Abfrage Gerät Typ Sensor Typ.',
  dashboard_tour_query_device_type_add: 'Hilfe: Abfrage Gerät Typ Hinzufügen.',
  dashboard_tour_query_prefer_flow: 'Hilfe: Abfrage Bevorzugung Durchfluss.',
  dashboard_tour_query_timespan_mode: 'Hilfe: Abfrage Zeitspanne Modus.',
  dashboard_tour_query_timespan_preset: 'Hilfe: Abfrage Zeitspanne Voreinstellung.',
  dashboard_tour_query_timespan_custom: 'Hilfe: Abfrage Zeitspanne benutzerdefiniert.',
  dashboard_tour_widget_actions: 'Hilfe: Widget Aktionen.',
  dashboard_tour_widget_delete: 'Hilfe: Widget Löschen.',
  dashboard_tour_dashboard_name: 'Hilfe: Dashboard Name.',
  dashboard_tour_dashboard_period: 'Hilfe: Dashboard Zeitraum.',
  dashboard_tour_dashboard_timespan_mode: 'Hilfe: Dashboard Zeitspanne Modus.',
  dashboard_tour_dashboard_timespan_preset: 'Hilfe: Dashboard Zeitspanne Voreinstellung.',
  dashboard_tour_dashboard_timespan_custom: 'Hilfe: Dashboard Zeitspanne benutzerdefiniert.',
  dashboard_tour_variable_add: 'Hilfe: Variable Hinzufügen.',
  dashboard_tour_variable_row: 'Hilfe: Variable Zeile.',
  dashboard_tour_variable_actions: 'Hilfe: Variable Aktionen.',
  dashboard_tour_variable_name_label: 'Hilfe: Variable Name Bezeichnung.',
  dashboard_tour_variable_type: 'Hilfe: Variable Typ.',
  dashboard_tour_variable_source: 'Hilfe: Variable Quelle.',
  dashboard_tour_variable_value: 'Hilfe: Variable Wert.',
  dashboard_tour_variable_actions_form: 'Hilfe: Variable Aktionen Formular.',
  dashboard_dialog_currently_open: 'Dialog ist derzeit geöffnet.',
};

export default i18n_de;
